var Kr = Object.create;
var Oe = Object.defineProperty;
var Br = Object.getOwnPropertyDescriptor;
var et = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), te = (e) => {
  throw TypeError(e);
};
var tt = (e, t, r) => t in e ? Oe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Je = (e, t) => Oe(e, "name", { value: t, configurable: !0 });
var ue = (e) => [, , , Kr(e?.[et("metadata")] ?? null)], rt = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], ee = (e) => e !== void 0 && typeof e != "function" ? te("Function expected") : e, kr = (e, t, r, n, i) => ({ kind: rt[e], name: t, metadata: n, addInitializer: (s) => r._ ? te("Already initialized") : i.push(ee(s || null)) }), re = (e, t) => tt(t, et("metadata"), e[3]), pe = (e, t, r, n) => {
  for (var i = 0, s = e[t >> 1], a = s && s.length; i < a; i++) t & 1 ? s[i].call(r) : n = s[i].call(r, n);
  return n;
}, D = (e, t, r, n, i, s) => {
  var a, o, c, l, d, p = t & 7, C = !!(t & 8), P = !!(t & 16), E = p > 3 ? e.length + 1 : p ? C ? 1 : 2 : 0, I = rt[p + 5], j = p > 3 && (e[E - 1] = []), h = e[E] || (e[E] = []), y = p && (!P && !C && (i = i.prototype), p < 5 && (p > 3 || !P) && Br(p < 4 ? i : { get [r]() {
    return Ze(this, s);
  }, set [r](R) {
    return Xe(this, s, R);
  } }, r));
  p ? P && p < 4 && Je(s, (p > 2 ? "set " : p > 1 ? "get " : "") + r) : Je(i, r);
  for (var S = n.length - 1; S >= 0; S--)
    l = kr(p, r, c = {}, e[3], h), p && (l.static = C, l.private = P, d = l.access = { has: P ? (R) => qr(i, R) : (R) => r in R }, p ^ 3 && (d.get = P ? (R) => (p ^ 1 ? Ze : Gr)(R, i, p ^ 4 ? s : y.get) : (R) => R[r]), p > 2 && (d.set = P ? (R, M) => Xe(R, i, M, p ^ 4 ? s : y.set) : (R, M) => R[r] = M)), o = (0, n[S])(p ? p < 4 ? P ? s : y[I] : p > 4 ? void 0 : { get: y.get, set: y.set } : i, l), c._ = 1, p ^ 4 || o === void 0 ? ee(o) && (p > 4 ? j.unshift(o) : p ? P ? s = o : y[I] = o : i = o) : typeof o != "object" || o === null ? te("Object expected") : (ee(a = o.get) && (y.get = a), ee(a = o.set) && (y.set = a), ee(a = o.init) && j.unshift(a));
  return p || re(e, i), y && Oe(i, r, y), P ? p ^ 4 ? s : y : i;
}, nt = (e, t, r) => tt(e, typeof t != "symbol" ? t + "" : t, r), Te = (e, t, r) => t.has(e) || te("Cannot " + r), qr = (e, t) => Object(t) !== t ? te('Cannot use the "in" operator on this value') : e.has(t), Ze = (e, t, r) => (Te(e, t, "read from private field"), r ? r.call(e) : t.get(e));
var Xe = (e, t, r, n) => (Te(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Gr = (e, t, r) => (Te(e, t, "access private method"), r);
import { ApplyModes as Vr, ApplyResponseCode as u, ApplicantType as z, ProviderApplyOperation as Re, DeviceType as oe, LogLevel as ne, useOmniApplyApiClient as g, BadRequestException as $t, OmniApplyApiClientKey as $r, OmniApplyClientPlugin as Wr, getOmniApplyClient as jr, ApiException as Hr, SendVerificationCodeStatus as Wt, VerifyCodeStatus as jt } from "@versatile-credit-apply/omni-apply-client";
import { computed as m, nextTick as x, toValue as f, onMounted as Ht, watch as q, unref as zr, inject as Ae, createApp as Yr, onUnmounted as zt, watchEffect as Qr, ref as F, toRaw as it } from "vue";
import { get as Yt, find as Jr, clamp as Zr, flatten as Xr, values as st, map as ot, set as at, keys as xe, sortBy as ct, keyBy as en, last as Qt } from "lodash-es";
import { daysBetween as tn, formatDate as rn, dayjs as lt, globalSuspense as nn, SynchronizingRouteGuard as Jt, HistoryRouteGuard as Zt, useApplicationLocales as sn, useApplicationI18n as on } from "@ui-kit/sdk";
import { daysBetween as qc, toLocalDate as Gc, useApplicationI18n as Vc } from "@ui-kit/sdk";
import { useMemoize as Xt, useAsyncState as be, useTimeoutFn as an, watchDebounced as cn, useDebounceFn as ln, computedAsync as dn, useScriptTag as un } from "@vueuse/core";
import { defineStore as k, getActivePinia as Pe, createPinia as pn } from "pinia";
import { createPersistedState as fn } from "pinia-plugin-persistedstate";
import { compile as hn } from "path-to-regexp";
import { EventBus as mn } from "@primeuix/utils/eventbus";
import { getRumSession as J, userAction as L } from "@ui-kit/instrumentation";
import dt from "js-cookie";
import { useRouter as Ve, createRouter as er, routerKey as yn, createRouterMatcher as vn, useRoute as tr, createWebHashHistory as rr } from "vue-router";
import { useI18n as $e } from "vue-i18n";
Object.defineProperty(Array.prototype, "first", {
  enumerable: !1,
  configurable: !0,
  value: function() {
    if (this.length === 0)
      throw new Error("Array[] is empty");
    return this[0];
  }
});
Object.defineProperty(Array.prototype, "firstOrUndefined", {
  configurable: !0,
  enumerable: !1,
  value: function() {
    return this.length ? this[0] : void 0;
  }
});
Object.defineProperty(String.prototype, "includesIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n <= t - r; n++) {
      let i = 0;
      for (; i < r && // @ts-expect-error will be defined
      this[n + i].toLowerCase() === e[i].toLowerCase(); )
        i++;
      if (i === r)
        return !0;
    }
    return !1;
  }
});
Object.defineProperty(String.prototype, "startsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (this[n].toLowerCase() !== e[n].toLowerCase())
        return !1;
    return !0;
  }
});
Object.defineProperty(String.prototype, "endsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (
        // @ts-expect-error will be defined
        this[t - r + n].toLowerCase() !== e[n].toLowerCase()
      )
        return !1;
    return !0;
  }
});
function Mo(e, t, r = "/apply") {
  const n = Object.values(Vr).join("|"), i = new RegExp(`${r}/(${n})/`);
  return e.replace(i, `${r}/${t}/`);
}
const ut = (e, t, r) => !t || t === "$it" ? r : Yt(e, t), gn = (e) => {
  if (e)
    return Array.isArray(e) ? e.length ? e[0] : void 0 : e.value?.length ? e.value[0] : void 0;
}, Io = (e, t) => {
  const r = e.find(t);
  if (r) {
    const n = e.indexOf(r);
    n > -1 && e.splice(n, 1);
  }
}, Pn = (e, t) => {
  if (e.length < 2)
    return e;
  const r = nr(t);
  return e.slice().sort(r);
}, nr = (e) => {
  if (typeof e == "string")
    return Sn(e);
  if (typeof e == "function")
    return An(e);
  if (Array.isArray(e))
    return wn(e);
  throw new Error(`Invalid sort rule: ${e}`);
}, wn = (e) => {
  const t = e.map(nr);
  return (r, n) => {
    for (const i of t) {
      const s = i(r, n);
      if (s !== 0)
        return s;
    }
    return 0;
  };
}, An = (e) => (t, r) => {
  const n = e(t), i = e(r);
  return n === i ? 0 : n < i ? -1 : 1;
}, Sn = (e) => {
  let t = "", r = e, n = 1;
  r.startsWith("-") && (n = -1, r = r.slice(1));
  const i = r.indexOf(":");
  i > -1 && (t = r.slice(i + 1), r = r.slice(0, i));
  const s = t.includes("i");
  return (a, o) => {
    let c = ut(a, r), l = ut(o, r);
    return s && (c = typeof c == "string" ? c.toLowerCase() : c, l = typeof l == "string" ? l.toLowerCase() : l), c === l ? 0 : c < l ? -1 * n : n;
  };
}, Oo = (e, t) => {
  let r = null;
  return () => {
    r && window.clearTimeout(r), r = window.setTimeout(e, t);
  };
}, To = (e, t) => {
  let r = null;
  return async () => (r && window.clearTimeout(r), new Promise((n, i) => {
    r = window.setTimeout(async () => {
      try {
        const s = await e();
        n(s);
      } catch (s) {
        i(s);
      }
    }, t);
  }));
}, ie = (e, t) => new Promise((r) => {
  setTimeout(() => {
    r(t());
  }, e);
}), _o = (e) => new Promise((t) => {
  setTimeout(() => {
    t();
  }, e);
}), Do = (e) => (t) => {
  for (const r of e)
    if (!r(t))
      return !1;
  return !0;
}, Fo = (e) => e.responseCode === u.APPROVED, Rn = (e) => e.responseCode === u.PENDING, pt = (e) => e.responseCode === u.PREQUALIFIED || e.responseCode === u.PREAPPROVED, No = (e) => (t) => t.providerKey === e.providerKey, bn = (e) => (t) => t.providerKey === e, ir = (e) => (t) => t.applicantType === e, xo = (e) => e.type ? ir(e.type) : () => !1, Lo = ir(
  z.JOINT
), sr = (e) => (t) => t.type === e, Uo = sr(z.PRIMARY), Ko = sr(z.JOINT), Bo = (e, t) => (r) => e(r) && t(r), Le = (e, t) => "value" in e ? e.value.find(t) : e.find(t), ko = (e, t) => m(() => Le(e, t)), Ue = (e, t) => "value" in e ? e.value.filter(t) : e.filter(t), qo = (e, t) => m(() => Ue(e, t));
class Ke {
  _value;
  _providerKey;
  _modifiers;
  constructor(t) {
    this._value = t;
    const r = t.indexOf(":");
    r > 0 ? (this._providerKey = t.substring(0, r), this._modifiers = new Map(
      t.substring(r + 1).split(":").map((n) => {
        const i = n.toLowerCase();
        return i.includes("=") ? i.split("=") : [i, "true"];
      })
    )) : (this._providerKey = t, this._modifiers = /* @__PURE__ */ new Map());
  }
  get providerKeyFqn() {
    return this._value;
  }
  get providerKey() {
    return this._providerKey;
  }
  get modifiers() {
    return this._modifiers;
  }
  get isJoint() {
    return this._modifiers.get("joint") === "true";
  }
  toString() {
    return this._value;
  }
}
const En = {
  asyncOfferAcceptance: !1,
  asyncApplicationSubmission: !1,
  asyncPrequalifySubmission: !1,
  submitAfterPrequalify: !1,
  asyncPrequalifySubmissionRequiresRefresh: !1,
  refreshApplicationAfterPrequalified: !1,
  displayPaymentCalculations: () => !0,
  displayPaymentPlanDetails: () => !0,
  excludePurchaseAmountFromMaxFinancing: !1,
  displayDeclineMessageWithOffer: !0,
  fetchPaymentPlansOnApproval: !0,
  fetchPaymentPlansOnPreauthApproval: !1,
  requiresAccountCreation: !1,
  requiresCodeVerification: !1,
  requiresEmailOnSmsVerification: !1,
  requiresSelectPlan: !0,
  supportsDownPaymentAdjustment: !0,
  supportsPurchaseAmountAdjustment: !1,
  supportsFullApply: !0,
  switchToFullApplyAfterPrequal: !1,
  termsType: "image",
  hydrationPostProcessing: {
    loadPaymentPlans: !0,
    loadPurchaseDetails: !1
  },
  accountFoundEndsApplication: !1
}, Cn = A(
  "acima",
  "acima_standard",
  {
    switchToFullApplyAfterPrequal: !0
  }
), Mn = A("ads", "ads_standard", {
  accountFoundEndsApplication: !0,
  requiresSelectPlan: !1
}), In = A("aff", "aff_standard", {
  excludePurchaseAmountFromMaxFinancing: !0
}), On = A("aqua", "aqua_standard", {
  asyncPrequalifySubmission: !0,
  termsType: "none"
}), Tn = A(
  "bread",
  "bread_standard",
  {
    hydrationPostProcessing: {
      loadPaymentPlans: !1,
      loadPurchaseDetails: !0
    },
    requiresCodeVerification: !0,
    requiresEmailOnSmsVerification: !0
  }
), ft = A(
  "versatile",
  "internal"
), _n = A(
  "dividend",
  "dividend_standard"
), Dn = A(
  "fortiva",
  "fortiva_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), Fn = A(
  "foundation",
  "foundation_standard",
  {
    asyncApplicationSubmission: !0,
    asyncPrequalifySubmission: !0,
    asyncPrequalifySubmissionRequiresRefresh: !0,
    refreshApplicationAfterPrequalified: !0,
    termsType: "none"
  }
), Nn = A("gafco", "gaf_standard"), xn = A(
  "genesis",
  "genesis_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0,
    termsType: "none"
  }
), Ln = A(
  "greensky",
  "greensky_standard",
  {
    asyncOfferAcceptance: !0,
    displayDeclineMessageWithOffer: !1,
    requiresAccountCreation: !0,
    supportsPurchaseAmountAdjustment: !0,
    supportsFullApply: !1,
    termsType: "html"
  }
), Un = A("hfd", "hfd_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnError: !0,
  fetchPaymentPlansOnPreauthApproval: !0,
  fetchPaymentPlansOnApproval: !1
}), Kn = A(
  "kafene",
  "kafene_standard"
), Bn = A(
  "koalafi",
  "koalafi_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), kn = A(
  "lendingclub",
  "lendingclub_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), qn = A(
  "lendingpoint",
  "lendingpoint_standard"
), Gn = A(
  "momnt",
  "momnt_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), Vn = A(
  "powerpay",
  "powerpay_standard",
  {
    termsType: "none"
  }
), $n = A("proceed", "proceed_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnApproval: !1,
  fetchPaymentPlansOnPreauthApproval: !0
}), Wn = A(
  "progressive",
  "progressive_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), jn = A(
  "service_finance",
  "service_finance_standard",
  {
    displayPaymentCalculations: (e) => e.tags["risk-based"] !== "true",
    displayPaymentPlanDetails: (e) => e.tags["risk-based"] !== "true",
    supportsDownPaymentAdjustment: !1
  }
), Hn = A(
  "sonrava",
  "sonrava_standard"
), zn = A("snap", "snap_standard", {
  fetchPaymentPlansOnApproval: !1
}), Yn = A(
  "sunlight",
  "sunlight_standard",
  {
    termsType: "none",
    submitAfterPrequalify: !0
  }
), Qn = A(
  "synchrony",
  "synchrony_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), Jn = A(
  "tdbank",
  "tdbank_standard"
), Zn = A("tguc", "tguc_standard", {
  termsType: "none"
}), Xn = A(
  "upgrade",
  "upgrade_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), ei = A(
  "watercress",
  "watercress_standard",
  {
    asyncPrequalifySubmission: !0,
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), ti = A(
  "wells_fargo",
  "wells_fargo_standard",
  {
    termsType: "none"
  }
), ri = [
  Cn,
  Mn,
  In,
  On,
  Tn,
  _n,
  Dn,
  Fn,
  Nn,
  xn,
  Ln,
  Un,
  Kn,
  Bn,
  kn,
  qn,
  Gn,
  Vn,
  $n,
  Wn,
  jn,
  Hn,
  zn,
  Yn,
  Qn,
  Jn,
  Zn,
  Xn,
  ei,
  ti
], N = (e) => e.indexOf(":") > 0 ? e.substring(0, e.indexOf(":")) : e, Go = (e) => e ? N(e) : null, U = (e) => {
  if (!e)
    return ft;
  let t = null;
  const r = (n) => n.providerId === e ? !0 : (t ??= N(e), n.providerKey === t);
  return ri.find(r) || ft;
};
function A(e, t, r) {
  return {
    ...En,
    ...r,
    providerId: e,
    providerKey: t
  };
}
class ni {
  _key;
  _applicant;
  _offers;
  _acceptedOffer;
  constructor(t, r, n) {
    this._key = hr(), this._applicant = t, this._offers = r, this._acceptedOffer = n;
  }
  get key() {
    return this._key;
  }
  get applicant() {
    return this._applicant;
  }
  get firstName() {
    return this._applicant.firstName || "";
  }
  get fullName() {
    return `${this.applicant.firstName} ${this.applicant.lastName}`.trim();
  }
  get offers() {
    return this._offers;
  }
  get prequalifiedOffers() {
    return Ue(this._offers, pt);
  }
  get pendingOffers() {
    return Ue(this._offers, Rn);
  }
  get acceptedOffer() {
    return this._acceptedOffer;
  }
  get isPrequalified() {
    return !this.hasAcceptedOffer && !!Le(this._offers, pt);
  }
  get hasAcceptedOffer() {
    return !!this._acceptedOffer;
  }
  get preauthResponseForAcceptedOffer() {
    if (this._acceptedOffer)
      return Le(
        this._offers,
        bn(this._acceptedOffer.providerKey)
      );
  }
  get providerModuleForAcceptedOffer() {
    return U(this._acceptedOffer?.providerKey);
  }
}
class Vo {
  _offers;
  _providerConfigs;
  constructor(t, r) {
    this._offers = t, this._providerConfigs = r;
  }
  get offers() {
    return this._offers;
  }
  get acceptedOffers() {
    return [...this._offers.values()].filter((t) => t.hasAcceptedOffer);
  }
  get prequalifiedOffers() {
    const t = this.acceptedOffers.length > 0, r = [...this._offers.values()].filter(
      (n) => n.isPrequalified
    );
    return t ? r.map((n) => {
      const i = n.prequalifiedOffers.filter(
        (s) => this.supportsMultipleApplicants(s.providerKey)
      );
      return new ni(
        n.applicant,
        i,
        n.acceptedOffer
      );
    }) : r;
  }
  get singleOffer() {
    const t = this.prequalifiedOffers;
    return gn(t);
  }
  get allPrequalifiedOffers() {
    return this.prequalifiedOffers.flatMap((t) => t.prequalifiedOffers);
  }
  get allPendingOffers() {
    return [...this._offers.values()].flatMap((t) => t.pendingOffers);
  }
  get jointApplicant() {
    return this._offers.get(z.JOINT);
  }
  get hasJointApplicant() {
    return this._offers.has(z.JOINT);
  }
  get hasAdditionalOffersToAccept() {
    const t = this.acceptedOffers;
    return !t.length || !(t.map(
      (n) => this.supportsMultipleApplicants(n.acceptedOffer?.providerKey)
    ).filter((n) => !n).length === 0) ? !1 : this.prequalifiedOffers.flatMap((n) => n.prequalifiedOffers).some((n) => this.supportsMultipleApplicants(n.providerKey));
  }
  supportsMultipleApplicants(t) {
    return t ? Jr(this._providerConfigs, {
      providerKey: t
    })?.supportsMultipleApplicantOfferAcceptance ?? !1 : !1;
  }
}
class fe {
  _start = null;
  _resume = null;
  _responses = [];
  _firstResponse = null;
  _lastResponse = null;
  _approvedResponse = null;
  _provider;
  _mode;
  _initialProvider;
  _initialMode;
  _autoSubmit = !1;
  _approvalCodes = [
    u.APPROVED,
    u.PREQUALIFIED,
    u.PREQUALIFIED
  ];
  constructor(t, r) {
    this._provider = t, this._mode = r, this._initialProvider = t, this._initialMode = r;
  }
  async execute(t) {
    return this.appendResponse(await t(this.provider)), this;
  }
  appendResponse(t) {
    const r = {
      ...t,
      applyMode: t.provider?.operation === Re.ACCEPT_OFFER ? "full" : this.mode
    };
    return this._responses.push(r), this._firstResponse ??= r, this.isApproved(r) && !this._approvedResponse && (this._approvedResponse = r), this._lastResponse = r, r;
  }
  get firstResponse() {
    if (!this._firstResponse)
      throw new Error("First Response not set!");
    return this._firstResponse;
  }
  get lastResponse() {
    if (!this._lastResponse)
      throw new Error("Last Response not set!");
    return this._lastResponse;
  }
  get approvedResponse() {
    return this._approvedResponse;
  }
  get autoSubmit() {
    return this._autoSubmit;
  }
  set autoSubmit(t) {
    this._autoSubmit = t;
  }
  get start() {
    return this._start;
  }
  set start(t) {
    this._start = t;
  }
  get resume() {
    return this._resume;
  }
  set resume(t) {
    this._resume = t;
  }
  get provider() {
    return this._provider;
  }
  set provider(t) {
    this._provider = t;
  }
  get mode() {
    return this._mode;
  }
  set mode(t) {
    this._mode = t;
  }
  get responses() {
    return [...this._responses];
  }
  isApproved(t) {
    return !!t.provider && this._approvalCodes.includes(t.provider?.responseCode);
  }
  hasLastResponse() {
    return this._lastResponse != null;
  }
}
class he {
  _context;
  _approvalCodes = [
    u.APPROVED,
    u.PREQUALIFIED,
    u.PREQUALIFIED
  ];
  _declineCodes = [
    u.DECLINED,
    u.NOOFFER
  ];
  constructor(t) {
    this._context = t;
  }
  get firstResponse() {
    return this._context.firstResponse;
  }
  get lastResponse() {
    return this._context.lastResponse;
  }
  get allResponses() {
    return this._context.responses;
  }
  shouldSwitchProviders() {
    return !!this._context.lastResponse && (this._context.start === !0 || this._context.resume === !0);
  }
  nextProvider() {
    return this._context.approvedResponse?.provider ? this._context.approvedResponse.provider?.providerKey : this._context.lastResponse?.next?.provider?.providerKey;
  }
  nextApplyMode() {
    return this._context.approvedResponse?.applyMode ? this._context.approvedResponse.applyMode : this._context.lastResponse?.next?.applyMode;
  }
  isResumingNextProvider() {
    return this._context.resume === !0;
  }
  getResponseToContinueWith() {
    if (this._context.approvedResponse?.provider)
      return this._context.approvedResponse;
    const t = (i) => {
      const s = i.provider?.responseCode;
      return !!s && this._approvalCodes.includes(s);
    }, r = this._context.responses.find(t);
    if (r)
      return r;
    const n = (i) => {
      const s = i.provider?.responseCode;
      return !!s && this._declineCodes.includes(s);
    };
    return this._context.responses.every(n) ? this._context.responses[0] : this._context.lastResponse;
  }
  getResponseForProvider(t) {
    return this._context.responses.find(
      (r) => r.provider?.providerKey === t
    );
  }
  hasMultipleOffers() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === u.PREQUALIFIED || n === u.PREAPPROVED;
    };
    return this._context.responses.filter(t).length > 1;
  }
  hasSingleOffer() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === u.PREQUALIFIED || n === u.PREAPPROVED || n === u.APPROVED;
    };
    return this._context.responses.filter(t).length === 1;
  }
}
var ii = /* @__PURE__ */ ((e) => (e.GROSS_MONTHLY = "gross_monthly", e.GROSS_ANNUAL = "gross_annual", e.NET_MONTHLY = "net_monthly", e.NET_ANNUAL = "net_annual", e))(ii || {}), Be;
((e) => {
  function t(i) {
    return typeof i != "object" ? !1 : "contentType" in i && "data" in i;
  }
  e.isContent = t;
  function r(i) {
    return {
      contentType: "text/html",
      data: i
    };
  }
  e.fromHtml = r;
  function n(i, s) {
    const a = Ee(i);
    return {
      contentType: s ?? Y.fromFilename(a.pathname) ?? "application/octet-stream",
      data: i
    };
  }
  e.fromUrl = n;
})(Be || (Be = {}));
var ht;
((e) => {
  function t(r) {
    return typeof r != "object" ? !1 : "content" in r && Be.isContent(r.content);
  }
  e.isContents = t;
})(ht || (ht = {}));
var ke = /* @__PURE__ */ ((e) => (e.COMPONENT = "component", e.HTML = "html", e.IMAGE = "image", e.PDF = "pdf", e.UNKNOWN = "unknown", e.VNODE = "vnode", e))(ke || {}), Y = /* @__PURE__ */ ((e) => (e.COMPONENT = "application/component", e.HTML = "text/html", e.IMAGE_GIF = "image/gif", e.IMAGE_JPEG = "image/jpeg", e.IMAGE_PNG = "image/png", e.JSON = "application/json", e.JSON_UTF8 = "application/json;charset=utf-8", e.MARKDOWN = "text/markdown", e.PDF = "application/pdf", e.TEXT = "text/plain", e.UNKNOWN = "application/octet-stream", e.VNODE = "application/vnode", e.XML = "text/xml", e.XML_APPLICATION = "application/xml", e))(Y || {});
const si = {};
for (const e in Y)
  si[e] = Y[e];
const oi = {
  gif: "image/gif",
  html: "text/html",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  json: "application/json",
  md: "text/markdown",
  pdf: "application/pdf",
  png: "image/png",
  txt: "text/plain",
  xml: "text/xml"
  /* XML */
};
((e) => {
  function t(n) {
    const i = n?.split(".")?.pop()?.toLowerCase();
    return oi[i ?? ""] ?? "application/octet-stream";
  }
  e.fromFilename = t;
  function r(n) {
    if (n.startsWithIgnoreCase("data:"))
      return n.split(";")[0].split(":")[1] ?? null;
    const i = n.split("/");
    if (i.length < 2)
      return null;
    const s = decodeURIComponent(i.at(-1));
    return t(s);
  }
  e.fromUri = r;
})(Y || (Y = {}));
((e) => {
  function t(r) {
    switch (r?.toLowerCase()) {
      case "application/component":
        return "component";
      case "text/html":
        return "html";
      case "image/gif":
      case "image/jpeg":
      case "image/png":
        return "image";
      case "application/pdf":
        return "pdf";
      case "application/vnode":
        return "vnode";
      default:
        return "unknown";
    }
  }
  e.fromContentType = t;
})(ke || (ke = {}));
var ai = /* @__PURE__ */ ((e) => (e[e.APPLY = 0] = "APPLY", e[e.PRINT = 1] = "PRINT", e))(ai || {});
class me {
  _type;
  _capabilities = [];
  constructor(t) {
    this._type = t, this._capabilities.push(
      0
      /* APPLY */
    ), t === oe.KIOSK && this._capabilities.push(
      1
      /* PRINT */
    );
  }
  get type() {
    return this._type;
  }
  get capabilities() {
    return [...this._capabilities];
  }
}
const ci = () => {
  if (window.kiosk)
    return new me(oe.KIOSK);
  const e = window.navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e) ? new me(oe.TABLET) : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    e
  ) ? new me(oe.MOBILE) : new me(oe.DESKTOP);
};
function $o(e, t) {
  return e ? li(e, t) : null;
}
function li(e, t) {
  return {
    contentType: e.contentType ?? t ?? Y.UNKNOWN,
    data: e.body
  };
}
var di = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PHONE = "phone", e))(di || {});
class mt {
  relative;
  url;
  constructor(t) {
    this.relative = typeof t == "string" && t.indexOf("://") < 0, this.url = pi(t);
  }
  get standard() {
    switch (this.protocol) {
      case "http:":
      case "https:":
      case "mailto:":
      case "tel:":
        return !0;
      default:
        return !1;
    }
  }
  get hash() {
    return this.url.hash;
  }
  get host() {
    return this.url.host;
  }
  get hostname() {
    return this.url.hostname;
  }
  get href() {
    return this.url.href;
  }
  get origin() {
    return this.url.origin;
  }
  get password() {
    return this.url.password;
  }
  get pathname() {
    return this.url.pathname;
  }
  get port() {
    return this.url.port;
  }
  get protocol() {
    return this.url.protocol;
  }
  get search() {
    return this.url.search;
  }
  get searchParams() {
    return this.url.searchParams;
  }
  get username() {
    return this.url.username;
  }
  toString() {
    return this.relative ? this.url.pathname + this.url.search + this.url.hash : this.url.toString();
  }
}
const or = () => window.location.protocol + "//" + window.location.host, ui = () => or() + window.location.pathname, Wo = (e) => {
  try {
    return Ee(e);
  } catch {
    return null;
  }
}, Ee = (e) => e instanceof mt ? e : new mt(e), pi = (e) => {
  if (e instanceof URL)
    return e;
  try {
    return new URL(e);
  } catch {
  }
  let t = e;
  if (e.indexOf("://") < 0) {
    const r = or();
    e.startsWith("/") ? t = r.endsWith("/") ? r + e.substring(1) : r + e : t = r.endsWith("/") ? r + e : r + "/" + e;
  }
  return new URL(t);
}, fi = (e, t = "file") => {
  try {
    return Ee(e).pathname?.split("/")?.pop() ?? t;
  } catch {
    return t;
  }
}, ye = (e, t) => {
  const r = Ee(e), n = r.searchParams;
  return Object.keys(t).forEach((i) => {
    const s = t[i];
    s != null && n.set(i, s);
  }), r;
}, jo = (e, t = "") => {
  const r = {
    sid: t,
    url: e
  };
  return "/api/v1/proxy?" + new URLSearchParams(r).toString();
}, We = "download", hi = (e, t) => {
  ar(e, t ?? fi(e, We));
}, yt = (e, t) => {
  const r = URL.createObjectURL(e);
  ar(r, t ?? We);
}, ar = (e, t, r = "_blank") => {
  const n = document.createElement("a");
  n.href = e, n.download = t ?? We, n.target = r, n.click();
}, mi = (e, t) => {
  e instanceof Promise ? e.then((r) => vt(r, t)) : "content" in e ? mi(e.downloadableContent ?? e.content, t) : vt(e, t);
}, vt = (e, t) => {
  e.data instanceof Blob ? yt(e.data, t) : typeof e.data != "string" || !yi(e.data) ? yt(
    new Blob([e.data], { type: e.contentType }),
    t
  ) : hi(e.data, t);
}, yi = (e) => e.startsWith("/") || e.startsWith("http://") || e.startsWith("https://") ? !0 : e.startsWith("data:");
async function cr(e) {
  const t = new TextEncoder().encode(e), r = await crypto.subtle.importKey("raw", t, "HKDF", !1, [
    "deriveKey"
  ]);
  return await crypto.subtle.deriveKey(
    {
      name: "HKDF",
      salt: new Uint8Array(0),
      info: new TextEncoder().encode("encryption"),
      hash: "SHA-256"
    },
    r,
    { name: "AES-GCM", length: 256 },
    !0,
    ["encrypt", "decrypt"]
  );
}
const vi = (e = 12) => crypto.getRandomValues(new Uint8Array(e));
async function gi(e, t, r) {
  const n = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    new TextEncoder().encode(e)
  );
  return Ce.toString(n);
}
async function Pi(e, t, r) {
  const n = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    Ce.toBinary(e)
  );
  return new TextDecoder().decode(n);
}
const Ce = {
  toBinary: (e) => new Uint8Array(
    atob(e).split("").map((t) => t.charCodeAt(0))
  ),
  toString: (e) => {
    let t = "";
    const r = e.byteLength, n = 32768, i = Math.ceil(r / n);
    for (let s = 0; s < i; s++) {
      const a = e.slice(
        s * n,
        Math.min((s + 1) * n, r)
      );
      t += String.fromCharCode(...new Uint8Array(a));
    }
    return btoa(t);
  }
};
var H = /* @__PURE__ */ ((e) => (e.CEIL = "ceil", e.FLOOR = "floor", e.HALF_EVEN = "halfeven", e))(H || {});
const wi = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "ceil"
}), Ai = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "floor"
}), gt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "halfExpand"
}), Si = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "ceil"
}), Ri = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "floor"
}), Pt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "halfExpand"
}), Ho = (e) => e == null ? null : typeof e == "number" ? e : parseFloat(e), zo = (e, t = "cents", r = !1, n = "halfeven") => {
  if (e == null)
    return null;
  let i = typeof e == "string" ? parseFloat(e) : e;
  return t === "cents" && (i = i / 100), bi(r, n).format(i);
}, Se = (e, t, r = 0, n = 0) => {
  const i = Math.max(t - e, 0), s = Math.max(t - n, 0);
  return Zr(
    r,
    i,
    s
  );
};
function bi(e, t) {
  if (e)
    switch (t) {
      case H.CEIL:
        return wi;
      case H.FLOOR:
        return Ai;
      case H.HALF_EVEN:
        return gt;
      default:
        return gt;
    }
  else
    switch (t) {
      case H.CEIL:
        return Si;
      case H.FLOOR:
        return Ri;
      case H.HALF_EVEN:
        return Pt;
      default:
        return Pt;
    }
}
const Ei = {
  isoDate: "YYYY-MM-DD",
  isoDateTime: "iso",
  localDate: "MM/DD/YYYY",
  localDateTime: "MM/DD/YYYY hh:mm A",
  localeDate: "MMMM DD, YYYY",
  localeDateNoLeadingZero: "MMMM D, YYYY"
}, Yo = (e, t, r = !1) => tn(e, t, {
  whole: !0,
  inclusive: r
});
function lr(e, t) {
  return rn(e, t);
}
function Qo(e) {
  return lr(e, "localDate");
}
function Jo(e) {
  return lr(e, "localeDate");
}
function Zo(e, t, r) {
  const n = typeof r == "string" ? Ei[r] : void 0, i = typeof t == "string" ? lt(t, n) : lt(t), a = (() => {
    switch (e) {
      case "weekly":
        return i.add(7, "day");
      case "bi_weekly":
        return i.add(14, "day");
      case "monthly":
        return i.add(1, "month");
      case "yearly":
        return i.add(1, "year");
      default:
        return;
    }
  })();
  return typeof t == "string" ? a?.format(n) : a?.toDate();
}
const dr = 1, Xo = (e, t = dr) => {
  const r = e.document;
  return e.innerHeight + Math.ceil(e.scrollY) + t >= r.body.scrollHeight;
}, ea = (e, t = dr) => e.clientHeight + Math.ceil(e.scrollTop) + t >= e.scrollHeight, ur = () => !!window.opener, pr = () => window.parent !== window, je = () => ur() || pr();
function ta(e) {
  return e.toLowerCase().replace("_", "-");
}
const ra = (e, t = ".p-invalid") => {
  (e ?? document).querySelector(t)?.scrollIntoView({
    block: "center"
  });
}, na = () => {
  history.pushState(null, document.title, window.location.href);
}, v = k("provider", {
  state: () => ({
    currentProviderKey: void 0,
    primary: void 0,
    cascade: [],
    providers: {},
    openedPaymentPlan: void 0,
    viewedOffers: []
  }),
  getters: {
    applyResponses: (e) => {
      const t = st(e.providers);
      return ot(t, "applyResponse").filter((r) => r != null);
    },
    currentProviderConfig: (e) => {
      const t = e.currentProviderKey;
      if (t != null)
        return e.providers[t]?.config ?? e.cascade.find((r) => r.providerKey === t);
    },
    preauthResponses: (e) => {
      const t = st(e.providers);
      return ot(t, "preauthResponse").filter((r) => r != null);
    }
  },
  actions: {
    addDisclosures(e, t) {
      const r = this.requireProviderSession(e);
      r.disclosures = Xr([...r.disclosures, t]);
    },
    findApplyResponse(e) {
      return this.requireProviderSession(e).applyResponse;
    },
    findDisclosures(e) {
      return this.requireProviderSession(e).disclosures ?? [];
    },
    findPreauthResponse(e) {
      return this.requireProviderSession(e).preauthResponse;
    },
    findProviderConfig(e) {
      return this.requireProviderSession(e).config;
    },
    findOverrides(e) {
      return this.requireProviderSession(e).overrides;
    },
    findPaymentPlan(e, t) {
      return this.findPaymentPlans(e).paymentPlans.find(
        (r) => r.providerPlanCode === t
      );
    },
    findPaymentPlans(e) {
      return this.requireProviderSession(e).paymentPlans ?? {
        paymentPlans: []
      };
    },
    findPurchaseDetails(e) {
      return this.requireProviderSession(e).purchaseDetails;
    },
    findResponseByMode(e, t) {
      return t == "full" ? this.findApplyResponse(e) : this.findPreauthResponse(e);
    },
    findStipulations(e) {
      return this.requireProviderSession(e).stipluations;
    },
    findTrustSessionId(e) {
      return this.requireProviderSession(e).trustSessionId;
    },
    initializeCascade(e) {
      this.cascade = e;
      for (const t of e) {
        const r = this.requireProviderSession(t.providerKey);
        r.config = t;
      }
    },
    initializeProvider(e) {
      const { providerKey: t, preauthResponse: r, applyResponse: n, paymentPlans: i } = e, s = this.requireProviderSession(t);
      r && (s.preauthResponse = r), n && (s.applyResponse = n), i?.length && (s.paymentPlans = {
        paymentPlans: i
      });
    },
    requireProviderSession(e) {
      let t = this.providers[e];
      return t == null && (t = {
        disclosures: [],
        providerKey: e,
        stipluations: []
      }, this.providers[e] = t), t.providerKey ??= e, t.config ??= this.cascade.find(
        (r) => r.providerKey === e
      ), t;
    },
    switchProvider(e) {
      this.currentProviderKey = e;
    },
    setTrustSessionId(e, t) {
      const r = this.requireProviderSession(e);
      r.trustSessionId = t;
    },
    setPaymentPlans(e, t) {
      const r = this.requireProviderSession(e);
      r.paymentPlans = t;
    },
    setPreauthResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.preauthResponse = e, r.stipluations = e.stipulations ?? [];
    },
    setApplyResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.applyResponse = e, r.stipluations = e.stipulations ?? [];
    },
    resetProvider(e) {
      delete this.providers[e];
    },
    setPurchaseDetails(e, t) {
      const r = this.requireProviderSession(e);
      r.purchaseDetails = t;
    },
    setStipulations(e, t) {
      const r = this.requireProviderSession(e);
      r.stipluations = t;
    },
    addOverrides(e, t) {
      const r = this.requireProviderSession(e);
      r.overrides = t;
    },
    addViewedOffer(e) {
      this.viewedOffers.push(e);
    },
    updateStipulation(e, t) {
      const r = this.requireProviderSession(e), n = r.stipluations.findIndex(
        (i) => i.id === t.id
      );
      n !== -1 && (r.stipluations[n] = t);
    }
  }
}), Q = k("locale", {
  state: () => ({
    experienceType: void 0,
    group: "versatile",
    language: "en",
    theme: "versatile"
  }),
  getters: {
    locale: (e) => `${e.group}_${e.language}`
  },
  actions: {
    doInitialize(e) {
      this.experienceType = e.experienceType, this.group = e.groupId, this.theme = e.themeId ?? e.groupId;
    }
  }
}), w = k("application", {
  state: () => ({
    application: void 0,
    jointSelectionEnabled: void 0,
    originalApplication: void 0,
    applyMode: void 0,
    applyStage: void 0,
    primaryProviderApplyMode: void 0,
    previousResponses: [],
    selectedPlan: void 0,
    stipulations: [],
    payments: []
  }),
  getters: {
    previousLender: (e) => (
      /**
       * Find the provider response that caused the transition to
       * the current lender.
       *
       * @param currentLender
       */
      ((t) => e.previousResponses.find(
        ({ next: r }) => r?.provider?.providerKey === t
      )?.provider)
    ),
    currentProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ provider: n }) => n?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    },
    previousProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ next: n }) => n?.provider?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    }
  },
  actions: {
    switchApplyMode(e) {
      this.applyMode = e, this.applyStage = e;
    },
    setApplicationValues(e) {
      const t = this.application = this.application ?? {};
      for (const r in e)
        at(t, r, e[r]);
      this.application = t;
    },
    getApplicationValue(e) {
      const t = this.application;
      return t ? Yt(t, e) : void 0;
    },
    setApplicationValue(e, t) {
      this.application = at(this.application ?? {}, e, t);
    },
    addResponse(e) {
      e.provider && !e.provider.applicantType && (e.provider.applicantType = z.PRIMARY), this.previousResponses.push(e);
    },
    updateStipulation(e) {
      this.stipulations = this.stipulations.map((t) => t.id === e.id ? e : t);
    },
    addPayment(e) {
      this.payments.push(e);
    }
  }
}), O = k("session", {
  state: () => ({
    id: void 0,
    flowSessionId: void 0,
    flowType: void 0,
    environment: void 0,
    properties: {},
    status: "IDLE",
    testCase: void 0,
    testCases: [],
    timeout: {},
    extensions: [],
    resume: void 0,
    storefrontSdk: void 0
  }),
  getters: {
    sessionId: (e) => e.id,
    isActive: (e) => !!e.id && e.status === "ACTIVE",
    needsRestore: (e) => !!e.id && e.status === "RESTORE_NEEDED",
    timedout: (e) => e.status === "TIMED_OUT",
    property: (e) => (t) => e.properties[t],
    providerResume: (e) => {
      const t = e.resume;
      return t && "applicationId" in t ? t : void 0;
    },
    waterfallResume: (e) => {
      const t = e.resume;
      return t && "waterfallSessionId" in t ? t : void 0;
    }
  },
  actions: {
    doRestore(e) {
      this.id = e, this.status = "RESTORE_NEEDED";
    },
    doTimeout() {
      this.status = "TIMED_OUT";
    },
    doInitialize(e) {
      this.id = e.webSessionId, this.environment = e.environment, this.flowSessionId = e.flowSessionId, this.flowType = e.flowType, this.properties = e.properties, this.testCases = e.testCases ?? [], this.testCase = void 0, this.extensions = e.extensions || [], this.storefrontSdk = e.storefrontSdk, this.timeout = {
        timeoutAfterMillis: e.sessionTimeoutMillis,
        warnAfterMillis: Math.max(
          0,
          e.sessionTimeoutMillis - e.sessionWarnCountdownMillis
        )
      }, this.resume = e.resume, this.status = "ACTIVE";
    },
    findExtensionsByFlowPosition(e) {
      return this.extensions.filter(
        (t) => t.flowPosition == e
      );
    },
    findExtensionById(e) {
      return this.extensions.find(
        (t) => t.featureId == e
      );
    },
    updateResume(e) {
      this.resume = e;
    }
  }
}), fr = "vst.appState", wt = () => {
  Object.keys(sessionStorage).forEach((e) => {
    e.startsWith(fr) && sessionStorage.removeItem(e);
  });
}, Ci = async (e, t) => {
  const r = e.$state, n = await cr(t), i = vi(), a = {
    state: await gi(JSON.stringify(r), n, i),
    iv: Ce.toString(i.buffer)
  };
  sessionStorage.setItem(qe(e), JSON.stringify(a));
}, Mi = async (e, t) => {
  const r = sessionStorage.getItem(qe(e));
  if (!r)
    throw new Error(`Unable to find ${qe(e)} in session store`);
  try {
    const n = JSON.parse(r), i = Ce.toBinary(n.iv), s = await cr(t), a = await Pi(n.state, s, i), o = JSON.parse(a);
    e.$patch(o), await x();
  } catch (n) {
    throw new Error(`Unable to read app state from session storage - ${n}`);
  }
};
function qe(e) {
  return `${fr}.${e.$id}`;
}
const Ge = k("error", {
  state: () => ({
    error: void 0,
    info: void 0
  })
}), $ = k("field", {
  state: () => ({
    fields: {},
    fieldArray: [],
    fieldsById: {},
    fieldGroupRules: [],
    fieldProviderKeys: []
  }),
  getters: {
    fieldByPath: (e) => (t) => e.fields[t],
    fieldById: (e) => (t) => e.fieldsById[t],
    fieldCount: (e) => xe(e.fields).length
  },
  actions: {
    addFields(e) {
      const t = /* @__PURE__ */ new Set(), r = [];
      this.fieldArray.forEach((n) => {
        t.add(n.id);
      }), e.forEach((n) => {
        this.fields[n.path] = n, this.fieldsById[n.id] = n, t.has(n.id) || r.push(n);
      }), r.length > 0 && this.fieldArray.push(...r);
    },
    setFields(e) {
      this.fields = {}, this.fieldArray = e, this.fieldsById = {}, e.forEach((t) => {
        this.fields[t.path] = t, this.fieldsById[t.id] = t;
      });
    },
    getFieldsByPath(...e) {
      const t = [];
      return e.forEach((r) => {
        const n = this.fieldByPath(r);
        n && t.push(n);
      }), t;
    },
    removeFieldsByPath(...e) {
      e.forEach((t) => {
        const r = this.fieldByPath(t);
        r && (delete this.fields[r.path], delete this.fieldsById[r.id]);
      });
    }
  }
}), He = k("merchant", {
  state: () => ({
    legalName: void 0,
    location: void 0,
    name: void 0,
    supportPhoneNumber: void 0,
    logoConfig: void 0,
    splashConfig: void 0,
    siteConfig: void 0
  }),
  actions: {
    doInitialize(e) {
      this.name = e.merchant?.name, this.legalName = e.merchant?.legalName, this.location = e.merchant?.location, this.logoConfig = e.merchant?.logoConfig, this.splashConfig = e.merchant?.splashConfig, this.supportPhoneNumber = e.merchant?.supportPhoneNumber, this.siteConfig = e.merchant?.siteConfig;
    }
  }
}), ia = k("navigation", {
  state: () => ({
    backPosition: void 0
  })
}), _ = k("app", {
  getters: {
    applyMode() {
      return w().applyMode;
    },
    currentProviderKey() {
      return v().currentProviderKey;
    },
    flowSessionId() {
      return O().flowSessionId;
    },
    group() {
      return Q().group;
    },
    applyResponse() {
      const e = v();
      return (t) => e.findApplyResponse(t);
    },
    preauthResponse() {
      const e = v();
      return (t) => e.findPreauthResponse(t);
    }
  },
  actions: {
    resetAll() {
      const e = Pe();
      if (!e)
        throw new Error("There is no active Pinia instance");
      e._s.forEach((t) => {
        ["merchant", "locale"].includes(t.$id) || t.$reset();
      }), wt();
    },
    clearedStoredAppStates() {
      wt();
    },
    async persistStoreToSession(e) {
      const t = Pe();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await Ci(r, e);
    },
    async reloadStoreFromSession(e) {
      const t = Pe();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await Mi(r, e);
    }
  }
}), Ii = () => {
  const e = Pe();
  if (!e)
    throw new Error("Unable to find Active Pinia!");
  e.use(
    fn({
      key: (t) => `__persisted__${t}`,
      storage: window.sessionStorage,
      auto: !0
    })
  );
}, sa = (e, t) => {
  const r = _(), n = Xt(e, t);
  return r.$onAction((i) => {
    i.name === "resetAll" && n.clear();
  }), n;
}, oa = (e, t = {}) => {
  const r = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: t.minimumFractionDigits ?? 2,
    maximumFractionDigits: t.maximumFractionDigits ?? 2
  }), n = typeof e == "string" ? parseFloat(e) : e;
  return r.format(n > 1 ? n / 100 : n);
}, aa = (e) => Promise.reject(new Error(e)), At = /* @__PURE__ */ Object.create(null);
function ca(e, t) {
  if (!t)
    return e;
  const r = {};
  Object.keys(t).forEach((n) => {
    const i = t[n];
    typeof i == "number" ? r[n] = String(i) : Array.isArray(i) ? r[n] = i.map((s) => s.toString()) : i != null && (r[n] = i);
  });
  try {
    const n = At[e] || (At[e] = hn(e));
    return typeof t.pathMatch == "string" && (t[0] = t.pathMatch), n(r);
  } catch {
    return "";
  } finally {
    delete t[0];
  }
}
const la = (e, t, r = 0, n = e?.length, i) => e && Oi(e, t, r, n ?? e.length, i), Oi = (e, t, r = 0, n = e.length, i) => {
  if (e = e ?? "", r < 0 && (r = e.length + r), n < 0 && (n = e.length + n), r < 0 && (r = 0), (n < 0 || n > e.length) && (n = e.length), r >= e.length)
    return e;
  const s = e.split("");
  for (let a = r; a < n; a++)
    i?.test(s[a]) || (s[a] = t);
  return s.join("");
}, St = (e) => e == null ? !0 : typeof e == "string" ? e.trim().length === 0 : !1, da = (e = "Not implemented") => {
  throw new Error("TODO: " + e);
}, hr = () => {
  let e = (/* @__PURE__ */ new Date()).getTime(), t = performance?.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
    let n = Math.random() * 16;
    return e > 0 ? (n = (e + n) % 16 | 0, e = Math.floor(e / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), (r === "x" ? n : n & 3 | 8).toString(16);
  });
}, ua = (e) => {
  if (e == null || /[^0-9-\s]+/.test(e))
    return !1;
  switch (e.substring(0, 1)) {
    case "3":
      return _i(e);
    case "4":
      return Ti(e);
    case "5":
      return Di(e);
    case "6":
      return Fi(e);
    default:
      return le(e);
  }
}, Ti = (e) => e.length === 16 && le(e), _i = (e) => e.length === 15 && le(e), Di = (e) => e.length === 16 && le(e), Fi = (e) => e.length === 16 && le(e), le = (e) => {
  let t = 0, r = 0, n = !1;
  for (let i = e.length - 1; i >= 0; i--) {
    const s = e.charAt(i);
    r = parseInt(s, 10), n && (r *= 2) > 9 && (r -= 9), t += r, n = !n;
  }
  return t % 10 === 0;
}, de = (e, t) => (t && (t.value = !1), async (...r) => {
  try {
    return t && (t.value = !0), await e(...r);
  } finally {
    t && (t.value = !1);
  }
});
var T = /* @__PURE__ */ ((e) => (e[e.TRACE = 0] = "TRACE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e))(T || {});
const Ni = (e) => {
  if (e.stack) {
    const t = e.stack.split(`
`), r = t[0]?.startsWith("Error") ? 4 : 3, n = t[r];
    if (n != null)
      return n.trim().replace("(", "").replace(")", "");
  }
}, xi = (e) => {
  if (e.includes("at "))
    return e.substring(e.indexOf("at ") + 3, e.lastIndexOf(" ")).split(".").reverse()[0];
  if (e.includes("@"))
    return e.substring(0, e.indexOf("@"));
}, Li = (e) => {
  const t = e.split(":").reverse(), r = t[2];
  if (r == null)
    return;
  const n = r.substring(
    Math.max(
      r.lastIndexOf("/"),
      r.lastIndexOf("\\")
    ) + 1
  ).split("?")[0], i = t[1];
  return {
    fileName: n,
    lineNumber: i
  };
};
class Ui {
  constructor(t, r, n) {
    this._name = t, this._isProduction = r, this._appenders = n;
  }
  trace(t, ...r) {
    this.log(T.TRACE, t, r);
  }
  debug(t, ...r) {
    this.log(T.DEBUG, t, r);
  }
  info(t, ...r) {
    this.log(T.INFO, t, r);
  }
  warn(t, ...r) {
    this.log(T.WARN, t, r);
  }
  error(t, ...r) {
    this.log(T.ERROR, t, r);
  }
  getCallerInfo() {
    const t = new Error();
    if (!t.stack)
      try {
        throw t;
      } catch {
      }
    if (t.stack)
      try {
        const r = Ni(t);
        if (r == null)
          return;
        const n = xi(r), i = Li(r);
        return {
          functionName: n,
          fileName: i?.fileName,
          lineNumber: i?.lineNumber
        };
      } catch (r) {
        f(this._isProduction) && console.debug(
          "vue-logger-plugin :: failed to determine caller function info:",
          r
        );
      }
  }
  log(t, r, n) {
    const i = [r, ...n], s = this.getCallerInfo();
    s && i.unshift(
      `[${s.fileName}:${s.functionName}:${s.lineNumber}]`
    ), this.append({
      name: f(this._name),
      level: t,
      args: i,
      caller: s
    });
  }
  append(t) {
    this._appenders.forEach((r) => r.append(t));
  }
}
class Ki {
  append(t) {
    switch (t.level) {
      case T.TRACE:
        console.trace(t.name, ...t.args);
        break;
      case T.DEBUG:
        console.debug(t.name, ...t.args);
        break;
      case T.INFO:
        console.info(t.name, ...t.args);
        break;
      case T.WARN:
        console.warn(t.name, ...t.args);
        break;
      case T.ERROR:
        console.error(t.name, ...t.args);
        break;
    }
  }
}
class Bi {
  _client;
  _store;
  constructor(t, r) {
    this._client = t, this._store = r;
  }
  append(t) {
    this._client.log({
      clientDateTime: (/* @__PURE__ */ new Date()).toISOString(),
      level: this.buildLevel(t),
      message: this.buildMessage(t),
      name: t.name,
      source: "versatile-credit-apply",
      tags: this.buildTags()
    }).catch((r) => {
      console.error(r);
    });
  }
  buildTags() {
    const t = [], r = this._store.group;
    r && t.push(`[group=${r}]`);
    const n = this._store.currentProviderKey;
    n && t.push(`[providerKey=${n}]`);
    const i = this._store.applyMode;
    return i && t.push(`[applyMode=${i}]`), t.filter((s) => s !== "");
  }
  buildLevel(t) {
    switch (t.level) {
      case T.TRACE:
        return ne.TRACE;
      case T.DEBUG:
        return ne.DEBUG;
      case T.INFO:
        return ne.INFO;
      case T.WARN:
        return ne.WARN;
      case T.ERROR:
        return ne.ERROR;
    }
  }
  buildMessage(t) {
    let r = "";
    return t.args.forEach((n) => {
      r += " " + this.argToString(n);
    }), r.trim();
  }
  argToString(t) {
    return t instanceof Error ? t.message : typeof t == "object" ? JSON.stringify(t) : String(t);
  }
}
class W {
  store;
  constructor(t) {
    this.store = t;
  }
  get applyMode() {
    const t = this.store.applyMode;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerModule() {
    return U(this.provider);
  }
  get provider() {
    const t = this.store.currentProviderKey;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerKey() {
    return N(this.provider);
  }
}
class ki extends W {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async getQuiz() {
    const t = await this.client.loadQuiz(this.provider);
    return t.questions = ct(t.questions || [], ["sequence"]), t.questions.forEach((r) => {
      r.choices = ct(r.choices || [], ["sequence"]);
    }), t;
  }
  answerQuiz(t) {
    return this.client.answerQuiz(this.provider, t);
  }
  lookupApplication() {
    return this.client.checkApplication(this.provider);
  }
}
class mr extends W {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async sendVerificationCode(t, r) {
    return await this.client.sendVerificationCode(
      r ?? this.provider,
      t
    );
  }
  async verifyVerificationCode(t, r) {
    return await this.client.verifyVerificationCode(
      r ?? this.provider,
      t
    );
  }
}
const ze = () => {
  const e = _(), t = b(
    () => `ApplicationService [${e.currentProviderKey}]`
  );
  return new ae(g(), e, t);
}, X = () => {
  const e = v();
  return m(() => e.currentProviderKey);
}, yr = () => {
  const e = X();
  return m(() => {
    const t = e.value;
    if (!t)
      throw Error("Provider is not set in the store!");
    return t;
  });
}, pa = (e) => {
  const t = X(), r = () => e ? f(e) : void 0;
  return m(() => {
    const n = r() ?? t.value;
    return n ? N(n) : void 0;
  });
}, fa = () => {
  const e = v(), t = yr(), r = m(() => e.cascade || []), n = m(
    () => r.value.find(
      (i) => N(i.providerKey) === N(t.value)
    )
  );
  return m(() => {
    if (!n.value)
      return !1;
    const i = r.value.indexOf(
      n.value
    );
    return i > -1 && i < r.value.length - 1;
  });
};
function vr(e) {
  const t = v();
  return m(() => {
    const r = f(e);
    if (!r)
      return;
    const n = t.currentProviderKey;
    return r === n ? t.currentProviderConfig : t.findProviderConfig(r);
  });
}
const ha = () => {
  const e = X();
  return vr(e);
}, ma = () => {
  const e = $();
  return m(() => e.fieldGroupRules);
}, ya = (e) => {
  const t = $();
  return m(() => {
    const r = f(e);
    return r ? t.fieldByPath(r) : void 0;
  });
}, qi = () => {
  const e = g();
  return (t) => e.getInvalidFields([f(t)]);
}, va = (e) => {
  const t = $();
  return m(() => t.fieldByPath(f(e)) != null);
}, ve = (e) => {
  const t = e.id.lastIndexOf(".");
  return t === -1 ? e.id : e.id.substring(0, t);
}, Gi = (e, t) => t?.waterfallStatus !== "completed" || t.waterfallOutcomeType !== "offer_present" && t.waterfallOutcomeType !== "additional_info_required" ? !1 : t.waterfallProviderKey === e, Vi = (e, t) => t.findIndex((r) => r.endsWith(".*") ? e.path.startsWith(r.substring(0, r.length - 2)) : e.path === r) > -1, $i = (e, t, r) => {
  const n = en(t, (a) => a.path), i = /* @__PURE__ */ new Set();
  return t.forEach((a) => {
    a.rules.forEach((o) => {
      if (o.id === "requiredIf") {
        const c = e.find(({ id: l }) => l == o.fieldId);
        c != null && ve(a) == ve(c) && i.add(c.id);
      }
      o.id === "requiredIfNotNullIn" && o.fieldDescriptors.forEach((c) => {
        ve(a) == ve(c) && i.add(c.id);
      });
    });
  }), [...e.filter((a) => n[a.path] == null).filter(
    (a) => i.has(a.id) || Vi(a, r)
  ), ...t];
}, ga = () => {
  const e = qi(), t = w(), r = v(), n = O(), i = $();
  return async (s, a) => {
    const o = f(s), c = t.previousResponses.length > 0, l = !!r.findPreauthResponse(o);
    if (c || l || Gi(f(s), n.waterfallResume)) {
      const d = await e(s);
      i.setFields(
        $i(i.fieldArray, d.fields, a || [])
      ), i.fieldGroupRules = d.fieldGroupRules, i.fieldProviderKeys = [f(s)];
    }
    return i.fieldCount > 0;
  };
}, Wi = (e) => m(() => {
  const t = f(e);
  return t ? U(t) : void 0;
}), gr = (e = {}) => {
  const t = w(), r = v(), n = $();
  return (i) => (t.switchApplyMode(i.applyMode), n.setFields(i.fields), n.fieldGroupRules = i.fieldGroupRules, n.fieldProviderKeys = i.fieldProviderKeys, r.currentProviderKey = i.providerKey, e.overwriteCascade && r.initializeCascade(i.providers), r.primary?.providerKey === i.providerKey && (t.primaryProviderApplyMode = i.applyMode), new ji(i.providerKey, !1));
}, Ye = () => {
  const e = b("useSwitchProvider"), t = g(), r = gr();
  return async (n) => {
    const { providerKey: i, applyMode: s } = n;
    e.info(
      `Switching to provider: ${i} and apply mode: ${s}`
    );
    const a = await t.startProviderApply(i, s);
    return r(a);
  };
};
class ji {
  constructor(t, r) {
    this._providerKey = t, this._resume = r;
  }
  get providerKey() {
    return this._providerKey;
  }
  get resume() {
    return this._resume;
  }
}
const Pa = () => new V(
  g(),
  _(),
  ze(),
  gr()
), wa = () => new As(g(), _()), Aa = () => {
  const e = g(), t = _();
  return new Ss(e, t);
}, Sa = () => {
  const e = g(), t = _();
  return new Rs(e, t);
}, Ra = () => new ws(g()), Pr = () => new mr(g(), _()), Hi = () => {
  const e = _();
  return new we(g(), e);
}, ba = () => {
  const e = g(), t = v();
  return async (r, n) => {
    const { status: i } = await e.getProviderStipulationStatus(
      r,
      n.id
    );
    t.updateStipulation(r, {
      ...n,
      status: i
    });
  };
}, zi = (e, t, r) => {
  J().reportCustomError(e, t, r, !0);
}, B = (e) => {
  if (e == null)
    return;
  const t = J();
  (e instanceof Error || typeof e == "string") && t.reportError(e);
}, Yi = (e) => {
  const t = w();
  return m(() => {
    const r = f(e), n = t.application;
    return r === z.PRIMARY ? n?.primary : n?.joint;
  });
}, Ea = (e, t) => {
  const r = g(), n = b("useApplicationDocuments"), i = async () => {
    const d = f(e), p = f(t) ?? [];
    return d ? (await r.getApplicationDocuments(
      d,
      ...p
    )).documents.reduce(
      (P, E) => ({ ...P, [E.type]: E }),
      {}
    ) : {};
  }, { error: s, isLoading: a, isReady: o, state: c, execute: l } = be(
    i,
    {},
    {
      onError: (d) => n.error(
        `Failed trying to fetch application documents for provider: ${f(e)}`,
        d
      )
    }
  );
  return {
    error: s,
    isLoading: a,
    isReady: o,
    state: c,
    refresh: l
  };
}, Qi = (e, t) => {
  const r = w(), n = v(), i = () => {
    const s = f(e), a = N(s);
    return a === "fortiva_standard" ? n.findApplyResponse(s) ? "agreement" : "credit_terms" : a === "hfd_standard" ? "esignDoc" : r.applyMode ?? "full";
  };
  return m(() => (t ? f(t).documentType : void 0) ?? i());
}, Ji = (e) => m(() => {
  switch (e ? f(e).contentType : void 0) {
    case "gif":
      return "image/gif";
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "pdf":
      return "application/pdf";
    case "html":
      return "text/html";
    case "text":
      return "text/plain";
    default:
      return;
  }
}), Zi = (e) => {
  const t = g(), r = Ji(e);
  return m(() => {
    const n = {
      sid: t.sessionId ?? ""
    };
    return r.value && (n.contentType = r.value), new URLSearchParams(n).toString();
  });
}, Ca = (e, t) => {
  const r = g(), n = Qi(e, t), i = Zi(t);
  return m(() => {
    const s = f(e), a = N(s), o = `${r.baseUrl}/api/v1/providers/${encodeURIComponent(s)}`;
    return a === "fortiva_standard" ? `${o}/documents/${n.value}?${i.value}` : `${o}/application/terms/${n.value}?${i.value}`;
  });
}, Ma = () => {
  const e = w();
  return m(() => e.application?.installationAddressSameAsPrimary ? e.application?.primary?.homeAddress : e.application?.installationLocation?.address);
}, Ia = () => {
  const e = w(), t = v();
  return m(() => {
    const r = Qt(e.previousResponses)?.next;
    return r?.provider?.providerKey === t.currentProviderKey ? void 0 : r;
  });
};
function Oa(e) {
  if (e.standard)
    return {
      type: "link",
      value: e.href,
      params: {}
    };
  const t = e.protocol, r = Xi(e.searchParams);
  return t === "route:" ? {
    type: "route",
    value: e.pathname,
    params: r
  } : {
    type: t + e.pathname,
    value: e.pathname,
    params: r
  };
}
function Xi(e) {
  const t = {};
  return e.forEach((r, n) => {
    t[n] = r;
  }), t;
}
const es = (e) => ({
  type: "checkout.transition",
  data: {
    applicationId: e.applicationId,
    resume: e.applicationWasResumed,
    token: e.token,
    from: "apply"
  },
  source: "vcredit"
}), ts = (e) => ({
  type: "start",
  data: {
    flowId: e.flow
  },
  source: "vcredit"
}), rs = (e) => {
  const t = () => {
    switch (e.outcome) {
      case "completed":
      case "pending":
        return "completed";
      case "canceled":
        return "canceled";
      case "timeout":
        return "abandoned";
    }
  };
  return {
    type: "end",
    data: {
      flowId: e.flow,
      exitStatus: t()
    },
    source: "vcredit"
  };
}, ns = (e) => ({
  type: "error",
  data: {
    category: e.category,
    cloudRequestId: e.cloudRequestId,
    code: e.code,
    message: e.message,
    httpStatusCode: e.httpStatusCode,
    httpMethod: e.httpMethod?.toLowerCase(),
    path: e.path
  },
  source: "vcredit"
}), is = (e) => {
  const r = w().application, i = v().findProviderConfig(e.response.providerKey), s = () => i?.providerProduct?.replace(/-/g, "_")?.toLowerCase(), a = () => {
    switch (i?.providerProductType) {
      case "credit":
        return "revolving_credit";
      case "lease":
        return "lease";
      case "loan":
        return "loan";
      default:
        return;
    }
  }, o = () => {
    switch (e.response.responseCode) {
      case u.OPEN:
      case u.APPROVED:
        return "approved";
      case u.NOOFFER:
        return "nooffer";
      case u.DECLINED:
        return "declined";
      case u.ERROR:
        return "error";
      case u.PENDING:
      case u.SUBMITTED:
        return "pending";
      case u.PREAPPROVED:
      case u.PREQUALIFIED:
        return "prequalified";
    }
  };
  return {
    type: "application.decision",
    // @ts-expect-error need to populate metadata
    data: {
      sessionId: e.sessionId,
      agreedToCascade: r?.hasAgreedToCascade,
      amount: e.response.approvedAmountCents,
      applicationId: e.response.versatileApplicationId,
      accountId: e.response.versatileAccountId,
      status: o(),
      providerId: e.response.providerId,
      providerReferenceNumber: e.response.applicationId ?? e.response.applicationReferenceNumber,
      providerProductId: s(),
      productType: a(),
      message: e.response.errors?.[0]?.errorMessage
    },
    source: "vcredit"
  };
}, ss = (e) => ({
  type: "page.view",
  data: {
    path: e.toUrl
  },
  source: "vcredit"
}), os = (e) => {
  switch (e.type) {
    case "checkout":
      return es(e);
    case "decision":
      return is(e);
    case "end":
      return rs(e);
    case "error":
      return ns(e);
    case "start":
      return ts(e);
    case "page-view":
      return ss(e);
    default:
      return;
  }
}, as = (e) => (r) => {
  const n = os(r);
  n && e.postMessage(n, "*");
}, cs = (e) => (t) => e.info("Event:", t), ls = () => (e) => {
  const t = K.getInstance();
  switch (e.type) {
    case "start":
      t.push({
        event: "app.start",
        event_start_flow: e.flow
      });
      break;
    case "end":
      t.push({
        event: "app.end",
        event_end_flow: e.flow,
        event_end_outcome: e.outcome
      });
      break;
    case "error":
      t.push({
        event: "app.error",
        event_error_code: e.code,
        event_error_message: e.message,
        event_error_category: e.category
      });
      break;
    case "decision":
      t.push({
        event: "app.decision",
        event_decision_provider: e.response.providerId
      });
      break;
    case "checkout":
      t.push({
        event: "app.checkout"
      });
      break;
  }
}, ds = () => {
  const e = g(), t = O();
  return (r) => {
    t.isActive && r.type === "page-view" && e.publishSessionPageView({
      toUrl: r.toUrl,
      fromUrl: r.fromUrl
    }).catch((n) => B(n));
  };
}, us = () => {
  const e = Nr(), t = [];
  if (je() && t.push(as(window.opener ?? window.parent)), t.push(ds()), t.push(ls()), e.mode === "development") {
    const r = b("LoggingEventPublisher");
    t.push(cs(r));
  }
  return t;
}, Z = () => {
  const e = us();
  return (t) => e.forEach((r) => r(t));
}, ps = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider)
      t.switchProvider(i.provider.providerKey), r.switchApplyMode(i.applyMode), await x(), await e.presentMultipleOffers(n);
    else
      throw new Error("Unhandled Cascade response!");
  };
}, fs = (e) => {
  const t = Ye();
  return async (r) => {
    const n = r.nextProvider(), i = r.nextApplyMode();
    if (n && i)
      if (await t({
        providerKey: n,
        applyMode: i
      }), await x(), r.isResumingNextProvider()) {
        const s = r.getResponseForProvider(n);
        if (!s)
          throw new Error(
            "Response was not returned for the provider " + n
          );
        await e.presentDecision(
          new Ke(n),
          s,
          r
        );
      } else
        await e.transitionTo(
          new Ke(n),
          i,
          r
        );
    else
      throw new Error("Unhandled Cascade response!");
  };
}, wr = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider) {
      const { providerKey: s } = i.provider;
      t.switchProvider(s), r.switchApplyMode(i.applyMode);
      const a = t.findProviderConfig(s);
      a && (i.provider.productType && (a.productType = i.provider.productType), i.provider.providerBankId && (a.providerBankId = i.provider.providerBankId)), await x(), await e.presentDecision(
        new Ke(s),
        i,
        n
      );
    } else
      throw new Error("Unhandled Cascade response!");
  };
}, hs = (e) => wr(e), ms = () => {
  const e = O();
  return m(() => e.extensions.find(
    (r) => r.featureId === "hosted-flow"
  )?.properties);
}, Rt = "vst.app_session", ys = () => {
  const e = ms(), t = O(), r = (a, o) => new Date(a.getTime() + o * 1e3);
  return {
    enabled: m(() => e.value !== null),
    clearSession: () => {
      dt.remove(Rt);
    },
    persistSession: () => {
      e.value && t.flowSessionId && dt.set(Rt, t.flowSessionId, {
        domain: e.value.cookieDomain,
        secure: !0,
        sameSite: "lax",
        expires: r(/* @__PURE__ */ new Date(), e.value.cookieDuration)
      });
    }
  };
}, Ta = (e) => vs(e, Re.ACCEPT_OFFER), vs = (e, t) => {
  const r = m(
    () => f(t) === Re.ACCEPT_OFFER
  ), n = b(
    () => r.value ? "use-accept-offer.ts" : "use-submit-application.ts"
  ), i = O(), s = ze(), a = wr(e), o = hs(e), c = fs(e), l = ps(e), d = Z(), p = ys(), C = (P) => {
    const E = i.flowSessionId;
    E && d({
      type: "decision",
      response: P,
      sessionId: E
    });
  };
  Ht(async () => {
    await x();
    let P;
    return r.value ? (n.info("Accepting Offer"), P = await s.acceptOffer()) : (n.info("Submitting Application"), P = await s.submitApplication()), P.allResponses.map((I) => I.provider).filter((I) => I != null).forEach(C), p.enabled.value && p.persistSession(), P.hasSingleOffer() ? (n.info("Handling Single Offer"), await o(P)) : P.hasMultipleOffers() ? (n.info("Handling Multiple Offers"), await l(P)) : f(e.canSwitchProviders ?? !0) && P.shouldSwitchProviders() ? (n.info("Handling Provider Transition"), await c(P)) : (n.info("Handling Standard Response"), await a(P));
  });
}, _a = () => {
  const e = b("use-patch-application.ts"), t = ze();
  return () => (e.info("Patching Application"), t.patchApplication());
}, Da = (e) => {
  const t = v(), r = X();
  return m(() => {
    const n = f(e) ?? r.value;
    return n ? t.findPreauthResponse(n) : void 0;
  });
}, Fa = () => {
  const e = g();
  return async (t) => e.publishUserOptOutProviderBypass(t);
}, Na = () => {
  const e = g();
  return async () => e.publishCascadeConsent({});
}, xa = () => {
  const e = g();
  return {
    confirmSelectedPlan: async (r, n) => e.confirmPaymentPlan(r, n)
  };
};
function La() {
  const e = w();
  return m(() => !!Qt(e.previousResponses)?.next?.topoff?.amountCents);
}
const ce = (e) => {
  const t = w(), r = v();
  return m({
    get: () => {
      const n = f(e);
      if (n) {
        const i = r.findOverrides(n);
        if (i?.purchaseAmountCents)
          return i.purchaseAmountCents;
      }
      return t.application?.purchaseAmountCents ?? void 0;
    },
    set: (n) => {
      const i = f(e);
      if (i) {
        const s = r.findOverrides(i);
        r.addOverrides(i, {
          ...s,
          purchaseAmountCents: n
        });
        return;
      }
      t.application && (t.application.purchaseAmountCents = n);
    }
  });
}, gs = () => {
  const e = w();
  return m(() => e.application?.downPaymentAmountCents ?? void 0);
}, Ps = (e) => {
  const t = v(), r = X();
  return m(() => {
    const n = f(e) ?? r.value;
    return n ? t.findApplyResponse(n) ?? t.findPreauthResponse(n) : void 0;
  });
};
var Tt, _t, Dt, Ft, se;
class ae extends (Ft = W, Dt = [L("Submit Application")], _t = [L("Patch Application")], Tt = [L("Accept Offer")], Ft) {
  constructor(r, n, i) {
    super(n);
    pe(se, 5, this);
    this.client = r, this.logger = i;
  }
  async submitApplication(r) {
    const n = new fe(this.provider, this.applyMode);
    switch (n.mode) {
      case "prescreen":
        await this.prescreen(n, r);
        break;
      case "prequalify":
        await this.prequalify(n, r);
        break;
      default:
        await this.apply(n, r);
    }
    return new he(n);
  }
  async patchApplication() {
    const r = this.buildCreditApp();
    if (!r)
      throw new Error("Invalid application state");
    const n = {
      application: r
    }, i = await this.client.patch(this.provider, n);
    return i.provider && v().setPreauthResponse(i.provider), i;
  }
  async acceptOffer() {
    const r = new fe(this.provider, this.applyMode);
    if (!this.buildCreditApp())
      throw new Error("Invalid application state");
    const i = async (s, a) => {
      let o = this.providerModule.asyncOfferAcceptance ? await this.client.submitApplication(this.provider, a) : await this.client.acceptOffer(this.provider, a);
      return o.provider?.responseCode === u.SUBMITTED && (o = await this.waitForOfferAcceptance(
        (/* @__PURE__ */ new Date()).getTime() + 6e4
      )), o.provider && (o.provider.operation = Re.ACCEPT_OFFER), o;
    };
    return await this.execute(r, {}, i), new he(r);
  }
  async addBankCard(r) {
    return await this.client.addBankCard(this.provider, r);
  }
  async addBankAccount(r) {
    return await this.client.addBankAccount(this.provider, r);
  }
  async initiateExternalApplication(r, n) {
    const i = await this.client.launchExternalApplication(
      r,
      n
    );
    if (!i.url)
      throw new Error("No redirect url received");
    const s = _(), a = s.flowSessionId;
    if (!a)
      throw new Error(
        "Unable to launch external application id without a sessionId"
      );
    await s.persistStoreToSession(a), this.logger.info(
      `Redirecting to external application URL - ${i.url}`
    ), window.location.href = i.url;
  }
  async addExternalResponse(r) {
    const n = new fe(
      this.provider,
      r.applyMode
    );
    return await this.execute(n, {}, async () => r), new he(n);
  }
  async waitForOfferAcceptance(r) {
    this.logger.info("Checking status of offer acceptance:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    switch (n.provider.responseCode) {
      case u.SUBMITTED:
        if (r > (/* @__PURE__ */ new Date()).getTime())
          return ie(5e3, () => this.waitForOfferAcceptance(r));
        break;
      case u.APPROVED:
        if (this.providerModule.requiresAccountCreation)
          return this.client.createAccount(this.provider);
        break;
    }
    return n;
  }
  async waitForApplicationStatus(r) {
    this.logger.info("Checking status of application status:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    return r > (/* @__PURE__ */ new Date()).getTime() && n.provider.responseCode === u.SUBMITTED ? ie(5e3, () => this.waitForApplicationStatus(r)) : n;
  }
  async waitForPrequalifyStatus(r, n) {
    this.logger.info(
      "Checking status of prequalify application status:",
      r.provider
    ), U(r.provider).asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(r.provider);
    const i = await this.client.checkPrequalifyApplication(
      r.provider
    );
    if (!i.provider)
      throw new Error("Provider is missing from response");
    return n > (/* @__PURE__ */ new Date()).getTime() && i.provider.responseCode === u.SUBMITTED ? ie(
      5e3,
      () => this.waitForPrequalifyStatus(r, n)
    ) : i;
  }
  async getIframeUrl() {
    return this.client.geIframeUrl(this.provider);
  }
  async getEsignIframeUrl(r) {
    return this.client.getEsignIframeUrl(this.provider, r);
  }
  async getEsignIframeUrlWithRedirect(r) {
    return this.client.getEsignIframeUrlWithRedirect(this.provider, r);
  }
  esignApplication(r = {}) {
    return this.providerKey === "aqua_standard" ? this.esignAquaApplication(r) : this.client.esign(this.provider, r);
  }
  // This is to workaround Aqua having a deadlock in their database.
  // Instead of them fixing their backend issues, they advised us to wait
  // and retry this.
  async esignAquaApplication(r) {
    let n = await this.client.esign(this.provider, r);
    if (n.responseCode === "error") {
      let i = 5;
      for (; i > 0 && n.responseCode === "error"; )
        this.logger.warn(
          `Retrying esign generation, previous attempt resulted in error, attempts remaining=${i}`
        ), n = await ie(
          3e4,
          () => this.client.esign(this.provider, r)
        ), i--;
    }
    return n.responseCode === "error" && this.logger.error(
      "Failed to esign application after repeated attempts with the lender"
    ), n;
  }
  async getEsignStatus() {
    return this.client.getEsignStatus(this.provider);
  }
  async getEsignStatuses() {
    return this.client.getEsignStatuses(this.provider);
  }
  async completeApplication() {
    return this.client.completeApplication(this.provider);
  }
  async paymentToken(r) {
    const n = w(), i = await this.client.paymentToken(this.provider, r);
    return (i.paymentToken || i.paymentType == "cash") && n.addPayment(i), i;
  }
  async hydrateProvider(r) {
    const n = w(), i = ce(this.provider), s = v();
    if (this.isApproved(r.responseCode)) {
      const a = U(r.providerKey), { loadPaymentPlans: o, loadPurchaseDetails: c } = a.hydrationPostProcessing;
      if (o && this.shouldFetchPlans(r)) {
        const l = r.approvedAmountCents ?? 0, d = i.value ?? 0, p = Se(
          l,
          d,
          n.application?.downPaymentAmountCents
        ), C = await this.client.getPaymentPlans(
          r.providerKey,
          d,
          p
        );
        s.setPaymentPlans(r.providerKey, C);
      }
      if (c) {
        const l = await this.client.getPurchaseDetails(
          r.providerKey
        );
        s.setPurchaseDetails(r.providerKey, l);
      }
    }
  }
  async continueCascade(r, n) {
    const i = new fe(this.provider, this.applyMode);
    return i.appendResponse(r), await this.handleResponse(i, n), new he(i);
  }
  async prequalify(r, n) {
    const i = U(r.provider);
    i.asyncPrequalifySubmission ? await this.execute(r, n, async (s, a) => {
      const o = await this.client.prequalify(s, a);
      return o?.provider?.responseCode === u.SUBMITTED ? this.doAfterAsyncPrequalify(o.provider.providerKey) : o;
    }) : i.submitAfterPrequalify ? await this.execute(r, n, async (s, a) => {
      const o = await this.client.prequalify(s, a);
      return o?.provider?.responseCode === u.SUBMITTED ? await this.client.submitAfterPrequalify(s) : o;
    }) : await this.execute(
      r,
      n,
      this.client.prequalify.bind(this.client)
    );
  }
  async doAfterAsyncPrequalify(r) {
    const n = U(r), i = await this.pollForPrequalifyStatus(
      n,
      r,
      (/* @__PURE__ */ new Date()).getTime() + 9e4
    );
    return i.provider?.responseCode === u.PREQUALIFIED && n.refreshApplicationAfterPrequalified ? await this.client.checkApplication(r) : i;
  }
  async pollForPrequalifyStatus(r, n, i) {
    this.logger.info(
      "Checking status of prequalify application status:",
      n
    ), r.asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(n);
    const s = await this.client.checkPrequalifyApplication(n);
    if (!s.provider)
      throw new Error("Provider is missing from response");
    return i > (/* @__PURE__ */ new Date()).getTime() && s.provider.responseCode === u.SUBMITTED ? ie(
      5e3,
      () => this.pollForPrequalifyStatus(r, n, i)
    ) : (s.provider.responseCode === u.SUBMITTED && (s.provider.responseCode = u.PENDING), s);
  }
  async handlePendingPrequalResume(r) {
    const n = r.providerKey, i = U(n);
    let s;
    if (i.asyncPrequalifySubmission ? s = await this.doAfterAsyncPrequalify(n) : i.submitAfterPrequalify && r?.responseCode === u.SUBMITTED ? s = await this.client.submitAfterPrequalify(n) : s = await this.client.checkPrequalifyApplication(n), !s.provider)
      throw new Error("Provider is missing from response");
    return v().setPreauthResponse(s.provider), s;
  }
  async rollbackLoan() {
    return this.client.rollbackLoan(this.provider);
  }
  async getDomainCategories(r) {
    return this.client.getDomainCategories(r);
  }
  async prescreen(r, n) {
    await this.execute(
      r,
      n,
      this.client.prescreen.bind(this.client)
    );
  }
  async apply(r, n) {
    this.providerModule.asyncApplicationSubmission ? await this.execute(r, n, async (i, s) => {
      const a = await this.client.submitApplication(
        i,
        s
      );
      return a?.provider?.responseCode === u.SUBMITTED ? this.waitForApplicationStatus(Date.now() + 4e4) : a;
    }) : await this.execute(r, n, this.client.apply.bind(this.client));
  }
  async execute(r, n = {}, i) {
    const s = this.buildCreditApp();
    if (!s)
      throw new Error("Invalid application state");
    const a = n.providerConfig ? n.providerConfig(r.provider) : void 0;
    this.addDeviceInfo(s), this.calculateIncome(s), this.setInstallationLocation(s);
    const o = v(), c = {
      application: s,
      autoSubmit: r.autoSubmit,
      returnUrl: a?.returnUrl,
      trustSessionId: o.findTrustSessionId(r.provider)
    };
    try {
      await r.execute((l) => i(l, c)), await this.handleResponse(r, n);
    } catch (l) {
      await this.handleError(r, l);
    }
  }
  async handleResponse(r, n) {
    const i = r.lastResponse;
    if (await this.storeResponse(r.provider, i), !i.provider) {
      const s = new Error("Unknown response, provider is missing");
      throw B(s), s;
    }
    if (i.provider?.responseCode === u.ERROR) {
      const s = i.provider;
      zi(
        "provider_application_error",
        `${s.providerKey} ${s.operation} resulted in error`,
        `versatile application id: ${s.versatileApplicationId}`
      );
    }
    if (i.provider.responseCode === u.PREAPPROVED || i.provider.responseCode === u.PREQUALIFIED) {
      const s = w();
      s.applyStage = "offer";
    }
    i.next && await this.cascade(r, n);
  }
  async handleError(r, n) {
    if (B(n), n instanceof $t)
      if (this.logger.error(
        `${r.provider} application contains validation errors`
      ), r.hasLastResponse()) {
        const i = r.lastResponse.next;
        if (i) {
          this.logger.info(`Forwarding cascade to start at ${r.provider}`), r.start = !0, i.validationError = n.error, i.autoSubmit = !1;
          return;
        }
      } else
        this.logger.warn(
          `Initial submission contained validation errors ${r.provider}, can't handle this here!`
        );
    throw this.logger.error(
      `FATAL: ${r.provider} application failed while submitting re-throwing`,
      n
    ), n;
  }
  async cascade(r, n) {
    if (!r.lastResponse.next)
      return;
    const i = r.lastResponse.next;
    if (i.resultType !== "provider") {
      this.logger.warn("Unknown resultType from Cascade", i.resultType);
      return;
    }
    if (r.autoSubmit = i.autoSubmit, !i.requireUserAction) {
      if (!i.autoSubmit) {
        r.start = !i.resume, r.resume = i.resume;
        return;
      }
      if (!i.topoff)
        switch (r.provider = i.provider.providerKey, r.mode = i.applyMode, i.applyMode) {
          case "prescreen":
            await this.prescreen(r, n);
            break;
          case "prequalify":
            await this.prequalify(r, n);
            break;
          default:
            await this.apply(r, n);
        }
    }
  }
  calculateIncome(r) {
    const n = r.primary?.income;
    n && this.normalizeIncome(n);
    const i = r.joint?.income;
    i && this.normalizeIncome(i);
  }
  addDeviceInfo(r) {
    if (!r.device) {
      const n = ci();
      r.device = {
        type: n.type
      };
    }
  }
  setInstallationLocation(r) {
    if (r.installationAddressSameAsPrimary) {
      const n = r.installationLocation;
      n && (n.address = r.primary?.homeAddress);
    }
  }
  normalizeIncome(r) {
    const n = r.grossAnnualCents, i = r.grossMonthlyCents;
    n != null && St(i) && (r.grossMonthlyCents = n / 12), i != null && St(n) && (r.grossAnnualCents = i * 12);
  }
  async storeResponse(r, n) {
    const i = w(), s = ce(r);
    if (i.addResponse(n), n.provider) {
      const a = v();
      if (n.applyMode === "full" ? a.setApplyResponse(n.provider) : a.setPreauthResponse(n.provider), i.stipulations = n.session?.stipulations ?? [], this.shouldFetchPlans(n.provider)) {
        const o = n.provider.approvedAmountCents ?? 0, c = s.value ?? o, l = Se(
          o,
          c,
          i.application?.downPaymentAmountCents
        ), d = await this.client.getPaymentPlans(
          r,
          c,
          l
        );
        a.setPaymentPlans(r, d);
      }
    }
  }
  isApproved(r) {
    return [
      u.PREQUALIFIED,
      u.PREAPPROVED,
      u.APPROVED
    ].includes(r);
  }
  shouldFetchPlans(r) {
    const n = U(r.providerId);
    return n.fetchPaymentPlansOnPreauthApproval && this.isPreApproved(r.responseCode) ? !0 : this.isApproved(r.responseCode) && n.fetchPaymentPlansOnApproval;
  }
  buildCreditApp() {
    const r = w();
    if (!r.application)
      return;
    const n = ce(this.provider);
    return {
      ...r.application,
      purchaseAmountCents: n.value
    };
  }
  isPreApproved(r) {
    return [
      u.PREQUALIFIED,
      u.PREAPPROVED
    ].includes(r);
  }
}
se = ue(Ft), D(se, 1, "submitApplication", Dt, ae), D(se, 1, "patchApplication", _t, ae), D(se, 1, "acceptOffer", Tt, ae), re(se, ae);
var Nt, xt, Lt, Ut, Kt, Bt, kt, G;
class V extends (kt = W, Bt = [L("Start Flow - Token")], Kt = [L("Start Flow - Entity Key")], Ut = [L("Start Flow - Default")], Lt = [L("Restart Flow")], xt = [L("Restore Flow")], Nt = [L("Reevaluate Cascade")], kt) {
  constructor(r, n, i, s) {
    super(n);
    pe(G, 5, this);
    this.client = r, this.applicationService = i, this.startProvider = s;
  }
  async startFlowWithToken(r, n) {
    return this.startFlow(() => this.client.startFlowWithToken(r), n);
  }
  async startFlowWithEntityKey(r, n = {}, i) {
    return this.startFlow(
      () => this.client.startFlowWithEntityKey(r, n),
      i
    );
  }
  async startFlowWithDefaultEntityKey(r) {
    return this.startFlow(
      () => this.client.startFlowWithDefaultEntityKey(),
      r
    );
  }
  async restartFlow(r) {
    const n = await this.client.restartFlow(), i = v();
    return n.providerConfigs.forEach((s) => {
      i.resetProvider(s.providerKey);
    }), this.startFlowWithResponse(n, r);
  }
  async restoreFlow(r, n) {
    return this.startFlowWithResponse(
      await this.client.restoreFlow(n),
      r
    );
  }
  async reevaluateCascade(r, n) {
    const i = await this.client.reevaluateCascade(r);
    return this.startFlowWithResponse(i, n);
  }
  async startFlow(r, n) {
    return this.store.resetAll(), this.startFlowWithResponse(await r(), n);
  }
  async startFlowWithResponse(r, n) {
    const i = J();
    switch (i.identify(r.flowSessionId), i.addStringActionProperty("flow-type", r.flowType), Q().doInitialize(r), He().doInitialize(r), O().doInitialize(r), r.flowType) {
      case "apply":
        return this.startApplyFlow(r, n);
      case "credit_limit_change":
        return this.startCreditLimitChangeFlow(r);
      case "pre_apply":
        return this.startPreApplyFlow(r);
      case "oh_my_bobs":
        return this.startBdfAssociateFlow(r);
      default:
        throw new Error(`Unsupported flow type: ${r.flowType}`);
    }
  }
  async startApplyFlow(r, n) {
    const i = w();
    if (i.application = structuredClone(r.application), i.originalApplication ??= structuredClone(
      r.application
    ), i.stipulations = r.sessionStipulations ?? [], !r.start.providers.length)
      throw new Error("Invalid Configuration - No providers are available.");
    const s = v();
    s.initializeCascade(r.start.providers), r.providerStates.length && r.providerStates.forEach(
      (d) => this.setupProviderState(r, d)
    ), i.primaryProviderApplyMode = r.start.applyMode, s.primary = r.start.providers[0];
    const a = this.startProvider(r.start);
    let o = !!r.resume, c = a.providerKey;
    const l = r.resume && "cascadeResponse" in r.resume ? r.resume.cascadeResponse : void 0;
    if (l) {
      i.addResponse({
        ...l,
        applyMode: r.start.applyMode
      });
      const d = await this.applicationService.continueCascade(
        l,
        n?.submitApp
      );
      o = !0, c = d.getResponseToContinueWith()?.provider?.providerKey ?? a.providerKey, this.resetStateAfterResume(s, c, r);
    }
    return {
      experienceType: r.experienceType,
      flowType: r.flowType,
      providerKey: c,
      resume: o
    };
  }
  startPreApplyFlow(r) {
    $().setFields(r.fields);
    const i = w();
    return i.originalApplication = structuredClone(r.application), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startBdfAssociateFlow(r) {
    const n = w();
    return n.originalApplication = structuredClone(r.application), v().initializeCascade(r.providerConfigs), r.providerStates.length && r.providerStates.forEach(
      (s) => this.setupProviderState(r, s)
    ), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startCreditLimitChangeFlow(r) {
    throw new Error("startCreditLimitChangeFlow not implemented.");
  }
  setupProviderState(r, n) {
    if (this.shouldIgnoreProviderState(r, n))
      return;
    v().initializeProvider(n);
  }
  resetStateAfterResume(r, n, i) {
    const s = i.providerStates.find(
      (a) => a.providerKey === n
    );
    s && this.shouldIgnoreProviderState(i, s) && r.resetProvider(n);
  }
  shouldIgnoreProviderState(r, n) {
    return !r.properties.resetToOffers || !n.applyResponse ? !1 : [
      u.PENDING,
      u.APPROVED,
      u.NOOFFER,
      u.DECLINED,
      u.SUBMITTED
    ].includes(n.applyResponse.responseCode);
  }
}
G = ue(kt), D(G, 1, "startFlowWithToken", Bt, V), D(G, 1, "startFlowWithEntityKey", Kt, V), D(G, 1, "startFlowWithDefaultEntityKey", Ut, V), D(G, 1, "restartFlow", Lt, V), D(G, 1, "restoreFlow", xt, V), D(G, 1, "reevaluateCascade", Nt, V), re(G, V);
class ws {
  client;
  constructor(t) {
    this.client = t;
  }
  async validateZipCode(t, r) {
    return (await this.client.validateZipCode({ state: t, zipCode: r })).valid;
  }
  async validatePhone(t) {
    return (await this.client.validatePhone({ phoneNumber: t })).valid;
  }
  async validateApplication(t, r) {
    const n = w();
    try {
      return await this.client.validateApplication({
        providerKeys: t,
        applicationData: n.application ?? {},
        fieldIds: r
      }), null;
    } catch (i) {
      if (i instanceof $t)
        return i.error;
      throw i;
    }
  }
}
var qt, Gt, Vt, ge;
class we extends (Vt = W, Gt = [L("Select Payment Plans")], qt = [L("Select Payment Plan")], Vt) {
  constructor(r, n) {
    super(n);
    pe(ge, 5, this);
    nt(this, "client");
    this.client = r;
  }
  getPaymentPlans(r, n, i) {
    const s = J();
    return s.addStringActionProperty("providerKey", r), s.addNumberActionProperty("purchaseAmountCents", n), s.addNumberActionProperty(
      "downPaymentAmountCents",
      i ?? 0
    ), this.client.getPaymentPlans(
      r,
      n,
      i
    );
  }
  async selectPaymentPlan(r) {
    const n = this.store.applyMode;
    if (!n)
      throw new Error("Invalid application state. ApplyMode is not set!");
    const i = w(), a = v().findResponseByMode(
      r.providerKey,
      n
    );
    if (!a)
      throw new Error(
        `Unable to locate provider response for ${r.providerKey} and ${n}`
      );
    const o = i.application?.purchaseAmountCents, c = Se(
      r.approvedAmountCents ?? a.approvedAmountCents ?? 0,
      o ?? 0,
      i.application?.downPaymentAmountCents
    ), l = J();
    l.addStringActionProperty("providerKey", r.providerKey), l.addStringActionProperty("providerPlanCode", r.providerPlanCode), l.addNumberActionProperty("financeAmountCents", o ?? 0), l.addNumberActionProperty(
      "downPaymentAmountCents",
      c ?? 0
    ), r.providerPlanId && l.addStringActionProperty("providerPlanId", r.providerPlanId);
    const d = {
      providerPlanCode: r.providerPlanCode,
      financeAmountCents: o,
      downPaymentAmountCents: c,
      offerId: r.providerPlanId,
      promotionalName: r.promotionalName
    };
    await this.client.selectPaymentPlan(r.providerKey, d), i.selectedPlan = r;
    const p = {
      providerKey: r.providerKey,
      paymentPlanCode: r.providerPlanCode
    };
    i.setApplicationValue("selectedOffer", p), i.setApplicationValue(
      "downPaymentAmountCents",
      c
    );
  }
  publishPlansPresented(r, n) {
    return this.client.publishPlansPresented({
      providerKeys: r,
      isSummary: n
    });
  }
  publishFinancingOptionSummaryPresented(r) {
    return this.client.publishFinancingOptionSummaryPresented(
      r
    );
  }
}
ge = ue(Vt), D(ge, 1, "getPaymentPlans", Gt, we), D(ge, 1, "selectPaymentPlan", qt, we), re(ge, we);
class As extends W {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async refreshProviderStipulations(t) {
    const { stipulations: r } = await this.client.refreshStipulations(t);
    v().setStipulations(t, r);
  }
  async refreshSessionStipulationStatus(t) {
    const { status: r } = await this.client.getStipulationStatus(t.id);
    w().updateStipulation({
      ...t,
      status: r
    });
  }
  async uploadStipulationDocument(t, r, n) {
    const i = {
      stipulationId: r.id,
      document: n
    };
    return this.client.uploadStipulationDocument(t, i);
  }
}
class Ss extends W {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  getApplyTermsUrl(t, r) {
    const n = this.provider, i = this.providerKey, s = this.client.baseUrl ?? "", a = this.client.sessionId ?? "", o = r ?? this.store.applyMode, c = {
      contentType: t,
      sid: a
    };
    switch (i) {
      case "fortiva_standard": {
        const d = v().findApplyResponse(i);
        return ye(
          `${s}/api/v1/providers/${n}/documents/${r ?? (d ? "agreement" : "credit_terms")}`,
          c
        ).toString();
      }
      case "hfd_standard":
        return ye(
          `${s}/api/v1/providers/${encodeURIComponent(n)}/application/terms/esignDoc`,
          c
        ).toString();
      default:
        return ye(
          `${s}/api/v1/providers/${n}/application/terms/${o}`,
          c
        ).toString();
    }
  }
  async getDisclosures(t, r) {
    return await this.client.getDisclosures(t, r);
  }
  getDisclosuresUrl(t) {
    const r = this.client.baseUrl ?? "", n = this.client.sessionId ?? "", i = t ?? this.provider, s = t ? N(t) : this.providerKey, a = {
      sid: n
    };
    return s === "fortiva_standard" ? (a.convertToImage = "false", ye(
      `${r}/api/v1/providers/${i}/documents/electronic_consent`,
      a
    ).toString()) : null;
  }
  getTermsHtml() {
    return this.client.getTermsHtml(this.provider);
  }
  getAgreementHtml() {
    return this.client.getAgreementHtml(this.provider);
  }
}
class Rs extends W {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async switchTestCase(t) {
    const r = await this.client.loadTestCase(t);
    if (r) {
      const n = w();
      n.applyMode = r.applyMode, n.applyStage = r.applyMode, n.application = { ...r.application }, n.originalApplication = {
        ...r.application
      }, r.fields.length && $().setFields(r.fields), r.providers.length && v().initializeCascade(r.providers);
    }
  }
}
const _e = {
  AccountServiceKey: /* @__PURE__ */ Symbol("accountService"),
  VerificationServiceKey: /* @__PURE__ */ Symbol(
    "verificationService"
  ),
  GoogleTagManagerKey: /* @__PURE__ */ Symbol(
    "google-tag-manager"
  ),
  OmniApplyClientKey: $r
}, bs = {
  install: (e, t) => {
    const r = _(), n = O();
    e.use(Wr, {
      baseUrl: t.api.omniApply.baseUrl,
      onSessionTimeout: () => n.doTimeout(),
      requestIdProvider: () => hr(),
      sessionProvider: () => n.sessionId
    });
    const i = jr(e);
    e.provide(
      _e.AccountServiceKey,
      new ki(i, r)
    ), e.provide(
      _e.VerificationServiceKey,
      new mr(i, r)
    ), e.provide(_e.GoogleTagManagerKey, new K());
  }
}, Es = (e) => {
  if (typeof e == "string")
    return {
      name: e.startsWith("/") ? void 0 : e,
      path: e.startsWith("/") ? e : void 0
    };
  const { to: t, params: r, ...n } = e;
  return t.startsWith("/") ? {
    path: t,
    ...n
  } : {
    name: t,
    params: r,
    ...n
  };
};
class Cs {
  router;
  loader;
  constructor(t, r) {
    this.router = t, this.loader = r;
  }
  listen() {
    const t = Q();
    q(
      () => t.group,
      (r) => this.loadGroupRoutes(r)
    ), t.group && this.loadGroupRoutes(t.group);
  }
  loadGroupRoutes(t) {
    nn(`routes-${t}`, async () => {
      const r = await this.loader(t);
      r?.length && this.importRoutes(t, r);
    });
  }
  importRoutes(t, r) {
    r.forEach((n) => this.importRoute(t, n));
  }
  importRoute(t, r, n = !0) {
    const i = r.name;
    r.meta = {
      ...r.meta || {},
      group: t
    }, i && (r.name = `${i.toString()}.${t}`);
    const s = r.meta.appendTo;
    s ? this.router.addRoute(s, r) : n && this.router.addRoute(r), r.children?.forEach((a) => this.importRoute(t, a, !1));
  }
}
const Ar = () => (e) => {
  const t = Dr();
  if (e.name === t.error)
    return !0;
  const r = O();
  if (r.needsRestore && e.meta.restore === !0 || r.isActive || e.meta.public === !0)
    return !0;
  const n = Ge();
  let i = t.unauthorized;
  return n.error && (i = t.error), r.timedout && (i = t.session_timeout), r.needsRestore && (i = t.session_restore), i.startsWith("/") ? {
    path: i,
    replace: !0
  } : {
    name: i,
    replace: !0
  };
}, Ms = () => (e, t) => {
  t.meta.cleanup && t.name && Ve().removeRoute(t.name);
}, Sr = () => async (e) => {
  const t = Dr();
  if (e.name === t.error)
    return !0;
  const r = new URLSearchParams(window.location.search), n = r.get("go"), i = r.get("returnId");
  if (!n)
    return !0;
  const s = _();
  i && await s.reloadStoreFromSession(i), s.clearedStoredAppStates(), r.delete("go"), r.delete("returnId");
  const a = new URL(window.location.href), o = {};
  for (const [c, l] of r.entries())
    o[c] = l, r.delete(c);
  return await x(), a.search = "", window.history.replaceState(null, "unused", a.toString()), {
    path: n,
    query: o,
    replace: !0
  };
}, Rr = () => (e, t) => {
  const r = Z();
  setTimeout(() => {
    r({
      type: "page-view",
      toUrl: e.fullPath,
      fromUrl: t.fullPath
    });
  }, 0), K.getInstance().push({
    event: "vue.RouteChange",
    current_page_name: e.name?.toString()?.replace(/-/g, " ")?.replace(/\./g, " ")?.replace(/\b\w/g, (n) => n.toUpperCase()),
    current_page_url: e.fullPath,
    previous_page_url: t.fullPath
  });
}, Is = (e, t) => e.path === t, Os = (e, t) => e.meta?.extends === t, br = (e, t) => {
  const r = e.meta || {}, n = !r.groupId || r.groupId === t.group, i = !r.applyMode || r.applyMode === t.mode, s = !r.providerKey || r.providerKey === t.providerKey;
  return n && i && s;
}, Er = (e, t) => xe(t.meta || {}).length - xe(e.meta || {}).length, bt = (e) => {
  const t = e.matched.length;
  return t ? e.matched[t - 1]?.path ?? e.path : e.path;
}, Cr = (e, t) => e.redirectedFrom ? e.redirectedFrom.name === t.name || Cr(e.redirectedFrom, t) : e.meta.extends === t.name, Ts = (e) => {
  const t = (n, i, s) => {
    if (n.meta.extends) {
      const o = e.router.getRoutes().find((c) => c.name === n.meta.extends);
      if (o) {
        const c = bt(i);
        return o.path === c && s.path !== c;
      }
    }
    const a = bt(i);
    return n.path === a && s.path !== a;
  }, r = (n) => n.params.finalized === "true";
  return (n, i) => {
    const s = e.router.computeGlobalRouteParams();
    if (r(n))
      return;
    const a = e.router.getRoutes().filter((o) => t(o, n, i)).filter((o) => br(o, s)).sort(Er);
    if (a.length) {
      const o = a[0];
      return o == null || Cr(n, o) || n.name === o.name ? void 0 : {
        name: o.name,
        params: {
          ...s,
          resolvedBy: o?.name?.toString(),
          finalized: "true"
        }
      };
    }
  };
};
class _s {
  router;
  listeners = [];
  store;
  routeByName = {};
  constructor(t, r) {
    this.router = this.buildRouter(t), this.store = r, this.router.addRoute({
      name: "__internal.error",
      path: "/internal/error",
      redirect: t.generalRouteMappings.error
    });
    const n = {
      routerSettings: t,
      router: this
    };
    this.beforeEach(Jt()), this.beforeEach(Sr()), this.beforeEach(Ar()), t.useLocalizedRouteGuard && this.beforeEach(Ts(n)), t.beforeResolve?.length && t.beforeResolve.forEach((i) => {
      this.beforeResolve(i(r));
    }), this.afterEach(Rr()), this.afterEach(Zt()), this.listeners.push(
      new Cs(this, t.groupRouteLoader)
    );
  }
  buildRouter(t) {
    const { routes: r, ...n } = t;
    this.populateRoutes(r);
    const i = this.mergeRoutes(r);
    return er({
      routes: i,
      ...n
    });
  }
  install(t) {
    this.router.install(t), t.config.globalProperties.$router = this, t.provide(yn, this), this.listeners.forEach((r) => r.listen());
  }
  get listening() {
    return this.router.listening;
  }
  get currentRoute() {
    return this.router.currentRoute;
  }
  get options() {
    return this.router.options;
  }
  addRoute(t, r) {
    if (typeof t == "string" && r)
      return this.populateRoute(r), this.router.addRoute(t, this.mergeRoute(r));
    const n = t;
    return this.populateRoute(n), this.router.addRoute(this.mergeRoute(n));
  }
  afterEach(t) {
    return this.router.afterEach(t);
  }
  back() {
    return this.router.back();
  }
  beforeEach(t) {
    return this.router.beforeEach(t);
  }
  beforeResolve(t) {
    return this.router.beforeResolve(t);
  }
  forward() {
    return this.router.forward();
  }
  findRouteByName(t) {
    return this.routeByName[t];
  }
  getRoutes() {
    return this.router.getRoutes();
  }
  go(t) {
    this.router.go(t);
  }
  hasRoute(t) {
    return this.router.hasRoute(t);
  }
  isReady() {
    return this.router.isReady();
  }
  push(t) {
    return this.router.push(this.computeRouteLocation(t));
  }
  removeRoute(t) {
    delete this.routeByName[t], this.router.removeRoute(t);
  }
  replace(t) {
    return this.router.replace(this.computeRouteLocation(t));
  }
  resolve(t, r) {
    return this.router.resolve(t, r);
  }
  onError(t) {
    return this.router.onError(t);
  }
  clearRoutes() {
    this.router.clearRoutes();
  }
  computeRouteLocation(t) {
    return typeof t == "string" ? this.computeRouteLocation({
      name: t.startsWith("/") ? void 0 : t,
      path: t.startsWith("/") ? t : void 0
    }) : "name" in t && t.name ? this.resolveByRouteName(t) : "path" in t && t.path ? this.resolveByRoutePath(t) : t;
  }
  resolveByRoutePath(t) {
    const n = vn(
      this.router.getRoutes(),
      this.router.options
    ).resolve(
      { path: t.path },
      zr(this.router.currentRoute)
    );
    if (n?.name)
      return this.resolveByRouteName({
        name: n.name,
        params: n.params,
        query: t.query
      });
    if (n?.matched.length) {
      const i = n.matched[n.matched.length - 1];
      if (i?.name)
        return this.resolveByRouteName({
          name: i.name,
          params: n.params,
          query: t.query
        });
    }
    return t;
  }
  resolveByRouteName(t) {
    const r = this.router.getRoutes().find((s) => s.name === t.name);
    if (!r)
      return t;
    const n = {
      ...this.computeGlobalRouteParams(),
      ...t.params
    }, i = this.router.getRoutes().filter(
      (s) => Is(s, r.path) || Os(s, r.name)
    ).filter((s) => br(s, n)).sort(Er);
    return i.length ? {
      name: i[0]?.name ?? r.name,
      hash: t.hash,
      params: n,
      query: t.query
    } : {
      name: r?.name,
      hash: t.hash,
      params: n,
      query: t.query
    };
  }
  computeGlobalRouteParams() {
    const t = this.store.group, r = this.store.applyMode, n = this.store.currentProviderKey, i = n ? N(n) : null;
    return {
      decision: (n ? this.store.applyResponse(n) || this.store.preauthResponse(n) : null)?.responseCode,
      group: t,
      mode: r,
      providerKey: i
    };
  }
  mergeRoutes(t) {
    return t.map((r) => this.mergeRoute(r));
  }
  mergeRoute(t) {
    let r = t;
    t.children && (r = {
      ...t,
      children: this.mergeRoutes(t.children)
    });
    const n = t.meta?.extends;
    if (!n)
      return r;
    const i = this.routeByName[n];
    if (!i)
      return r;
    const s = i.meta;
    if (!s)
      return r;
    const a = r.meta, o = a ? { ...s, ...a } : s;
    return !o || a === o || (r === t && (r = { ...t }), r.meta = o), r;
  }
  populateRoutes(t) {
    t.forEach((r) => {
      this.populateRoute(r);
    });
  }
  populateRoute(t) {
    if (t.name) {
      const r = t.name;
      if (this.routeByName[r])
        throw new Error(`Route name [${r}] is already defined.`);
      this.routeByName[r] = t;
    }
    t.children && this.populateRoutes(t.children);
  }
}
const Ds = (e) => (t) => e.runWithContext(() => {
  const r = b("GlobalErrorHandler");
  r.error(
    "attempting to recover from preload error ->",
    t.payload.message
  );
  const n = _(), i = n.flowSessionId;
  if (!i) {
    r.error("Unable to recover from preload, no flowSessionId");
    return;
  }
  const s = tr();
  n.persistStoreToSession(i).then(() => {
    const a = new URL(ui());
    a.searchParams.append("go", s.fullPath), a.searchParams.append("returnId", i), window.location.replace(a);
  });
}), Fs = (e) => {
  window.addEventListener("vite:preloadError", Ds(e));
}, Mr = {
  install: (e, t) => {
    const r = e.config.globalProperties.$router, n = () => {
      const i = e.runWithContext(
        () => b("GlobalErrorHandler.attemptErrorNavigation")
      );
      x().then(() => r.replace(Es(t))).catch((s) => {
        B(s), i.error(`Failed to navigate to error route ${t}`, s);
      });
    };
    r.onError((i, s, a) => {
      B(i), e.runWithContext(() => {
        const o = b("GlobalErrorHandler"), c = Ge(), l = Z(), d = `Error Routing to ${s.name?.toString()} from ${a.name?.toString()}`;
        o.error(d, i), c.error = i, c.info = d, l({
          type: "error",
          category: "navigation",
          code: "app",
          message: d
        });
      }), n();
    }), e.config.errorHandler = (i, s, a) => {
      B(i), e.runWithContext(() => {
        const o = b("GlobalErrorHandler"), c = Ge();
        o.error(a, i), c.error = i, c.info = a;
        const l = Z();
        i instanceof Hr ? l({
          type: "error",
          category: i.error.category,
          code: i.error.code,
          message: i.error.message,
          cloudRequestId: i.cloudRequestId,
          httpStatusCode: i.statusCode,
          httpMethod: i.httpMethod,
          path: i.path
        }) : l({
          type: "error",
          category: "unknown",
          code: "app",
          message: a
        });
      }), n();
    }, Fs(e);
  }
}, Qe = {
  error: "/error/general",
  exit: "/exit",
  session_restore: "/session/restore",
  session_timeout: "/error/timeout",
  unauthorized: "/error/unauthorized"
}, Ns = (e) => (t) => {
  if (typeof t == "boolean")
    return t;
  const r = typeof t == "string" ? e.conditions[t] : t;
  return typeof r == "function" && r({
    route: e.currentRoute.value
  });
}, Ir = /* @__PURE__ */ Symbol("general-route-mappings"), Or = /* @__PURE__ */ Symbol("route-condition-evaluator"), Tr = (e, t, r) => {
  const n = Ns({
    currentRoute: t.currentRoute,
    conditions: r
  });
  e.provide(Or, n);
}, _r = () => ({
  top: 0
}), xs = (e, t) => {
  const r = er({
    ...t,
    history: rr(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? _r
  }), n = {
    ...Qe,
    ...t.generalRouteMappings ?? {}
  };
  r.addRoute({
    name: "__internal.error",
    path: "/internal/error",
    redirect: n.error
  }), r.beforeEach(Jt()), r.beforeEach(Sr()), r.beforeEach(Ar()), r.afterEach(Rr()), r.afterEach(Zt()), r.afterEach(Ms()), t.customizeRouter && t.customizeRouter(r), e.use(r).use(Mr, n.error), Tr(e, r, {});
}, Ls = (e, t) => {
  const r = {
    ...t,
    routeConditions: t.routeConditions ?? {},
    generalRouteMappings: t.generalRouteMappings ?? Qe,
    history: rr(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? _r
  };
  e.provide(Ir, r.generalRouteMappings);
  const n = new _s(r, _());
  e.use(n).use(Mr, r.generalRouteMappings.error), Tr(e, n, r.routeConditions ?? {});
}, Us = {
  install: (e, t) => {
    t.mode === "complicated" ? Ls(e, t) : xs(e, t);
  }
}, Dr = () => ({
  ...Qe,
  ...Ae(Ir, void 0) ?? {}
}), Ks = () => {
  const e = Ae(Or);
  if (!e)
    throw new Error("RouteConditionEvaluator has not been provided!");
  return e;
}, Ua = (e) => {
  const t = Ks(), r = tr();
  return m(() => t(typeof e == "function" ? e(r.meta) : r.meta[e]));
}, Ka = () => {
  const e = Ve();
  return () => e.replace({
    name: "__internal.error"
  });
}, Bs = (e, t) => (t.forEach((r) => {
  const n = r.meta || {};
  n.providerKey = e, r.meta = n, r.children && Bs(e, r.children);
}), t), Ba = (e, t) => {
  let r;
  const n = e.matched.length;
  return n > 1 ? r = e.matched[n - 2].path : r = e.matched[0].path, `${r}/${t}`;
}, Fr = /* @__PURE__ */ Symbol("app-options"), ks = {
  install(e, t) {
    const r = mn();
    if (e.config.globalProperties.$appOptions = t, e.config.globalProperties.$eventBus = r, e.use(pn()), t.mode === "development" && Ii(), e.provide(Fr, t).use(t.i18n).use(bs, t).use(Us, t.router), t.plugins?.forEach((n) => e.use(n)), t.configurePlugins) {
      const n = e.use.bind(e);
      t.configurePlugins(n);
    }
  }
}, qs = (e) => Yr(e.root).use(ks, e), Nr = () => {
  const e = Ae(Fr) ?? Ae("app-options");
  if (!e)
    throw new Error("Unable to find active SDK instance, did you install it?");
  return e;
}, ka = (e) => {
  const t = qs(e);
  return t.mount(e.rootContainer ?? "#app"), Gs(), t;
};
function Gs() {
  const e = document.body;
  e.classList.add("vc-body"), ur() && e.classList.add("vc-window--has-opener"), pr() && e.classList.add("vc-window--has-parent"), je() && e.classList.add("vc-window--opened-externally");
}
const Vs = () => {
  let e = !1;
  try {
    e = Nr().mode === "production";
  } catch (t) {
    console.debug(t);
  }
  return m(() => e);
}, b = (e) => {
  const t = Vs(), r = g(), n = _();
  return new Ui(e, t, [
    new Ki(),
    new Bi(r, n)
  ]);
}, Me = (e, t, r = { immediate: !0 }) => {
  const n = b("use-polling.ts"), i = async () => {
    let o = !1;
    try {
      await e() && (o = !0);
    } catch (c) {
      n.error("Uncaught error in polling...we'll keep trying", c);
    }
    o || s();
  }, { start: s, stop: a } = an(
    i,
    t,
    {
      immediate: !1
    }
  );
  return Ht(async () => {
    r.manual || (r.immediate ? await i() : s());
  }), zt(() => a()), {
    start: s,
    stop: a
  };
};
window.dataLayer == null && (window.dataLayer = []);
class K {
  static GLOBAL;
  _dataLayer = window.dataLayer;
  constructor() {
    this.setInitialEnvironment(), this.listen(), K.GLOBAL || (K.GLOBAL = this);
  }
  set flowSessionId(t) {
    this._dataLayer.push({ apply_session_id: t });
  }
  set environment(t) {
    this._dataLayer.push({ environment: t });
  }
  set groupId(t) {
    this._dataLayer.push({ group_id: t });
  }
  set provider(t) {
    this._dataLayer.push({ current_provider_key: t });
  }
  set applyMode(t) {
    this._dataLayer.push({ current_apply_mode: t });
  }
  push(t) {
    this._dataLayer.push(t);
  }
  setInitialEnvironment() {
    const t = window.location.host;
    t.startsWith("apply-next-demo") ? this.environment = "demo" : t.startsWith("apply-next-test") ? this.environment = "test" : t.startsWith("apply-next-uat") ? this.environment = "uat" : t === "apply-next.versatilecredit.com" || // Whitelabel domains (maybe...) lol
    t.indexOf("versatilecredit") === -1 && t.indexOf(".com") > -1 ? this.environment = "prod" : this.environment = "dev";
    const r = Q();
    this.groupId = r.group;
    const n = w();
    this.applyMode = n.applyMode;
    const i = v();
    this.provider = i.currentProviderKey;
    const s = O();
    this.flowSessionId = s.flowSessionId;
  }
  listen() {
    const t = Q();
    q(
      () => t.group,
      (s) => this.groupId = s
    );
    const r = w();
    q(
      () => r.applyMode,
      (s) => this.applyMode = s
    );
    const n = v();
    q(
      () => n.currentProviderKey,
      (s) => this.provider = s
    );
    const i = O();
    q(
      () => i.environment,
      (s) => this.environment = s
    ), q(
      () => i.flowSessionId,
      (s) => this.flowSessionId = s
    );
  }
  static getInstance() {
    return K.GLOBAL || (K.GLOBAL = new K()), K.GLOBAL;
  }
}
const qa = (e) => {
  const t = g();
  return {
    exists: (r) => t.checkUserExists(f(e), r)
  };
}, Ga = (e) => {
  const t = g();
  return {
    login: (r) => t.providerUserLogin(f(e), r)
  };
}, Va = (e) => {
  const t = g();
  return {
    send: (r) => t.sendProviderUserPasscode(f(e), r)
  };
};
function $s(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var De, Et;
function Ws() {
  if (Et) return De;
  Et = 1;
  var e = function(y) {
    return t(y) && !r(y);
  };
  function t(h) {
    return !!h && typeof h == "object";
  }
  function r(h) {
    var y = Object.prototype.toString.call(h);
    return y === "[object RegExp]" || y === "[object Date]" || s(h);
  }
  var n = typeof Symbol == "function" && Symbol.for, i = n ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function s(h) {
    return h.$$typeof === i;
  }
  function a(h) {
    return Array.isArray(h) ? [] : {};
  }
  function o(h, y) {
    return y.clone !== !1 && y.isMergeableObject(h) ? I(a(h), h, y) : h;
  }
  function c(h, y, S) {
    return h.concat(y).map(function(R) {
      return o(R, S);
    });
  }
  function l(h, y) {
    if (!y.customMerge)
      return I;
    var S = y.customMerge(h);
    return typeof S == "function" ? S : I;
  }
  function d(h) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(h).filter(function(y) {
      return Object.propertyIsEnumerable.call(h, y);
    }) : [];
  }
  function p(h) {
    return Object.keys(h).concat(d(h));
  }
  function C(h, y) {
    try {
      return y in h;
    } catch {
      return !1;
    }
  }
  function P(h, y) {
    return C(h, y) && !(Object.hasOwnProperty.call(h, y) && Object.propertyIsEnumerable.call(h, y));
  }
  function E(h, y, S) {
    var R = {};
    return S.isMergeableObject(h) && p(h).forEach(function(M) {
      R[M] = o(h[M], S);
    }), p(y).forEach(function(M) {
      P(h, M) || (C(h, M) && S.isMergeableObject(y[M]) ? R[M] = l(M, S)(h[M], y[M], S) : R[M] = o(y[M], S));
    }), R;
  }
  function I(h, y, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || c, S.isMergeableObject = S.isMergeableObject || e, S.cloneUnlessOtherwiseSpecified = o;
    var R = Array.isArray(y), M = Array.isArray(h), Ur = R === M;
    return Ur ? R ? S.arrayMerge(h, y, S) : E(h, y, S) : o(y, S);
  }
  I.all = function(y, S) {
    if (!Array.isArray(y))
      throw new Error("first argument should be an array");
    return y.reduce(function(R, M) {
      return I(R, M, S);
    }, {});
  };
  var j = I;
  return De = j, De;
}
var js = Ws();
const Hs = /* @__PURE__ */ $s(js), $a = () => {
  const e = g(), t = w(), r = v();
  return async (n, i) => {
    const s = await e.accountLookup(n, i), { responseCode: a } = s.applicationResponse;
    switch (a) {
      case "prequalified":
        t.switchApplyMode("prequalify"), r.setPreauthResponse(s.applicationResponse), s.applicationData && (t.application = t.application ? Hs(t.application, s.applicationData) : structuredClone(s.applicationData));
        break;
      case "approved":
        t.switchApplyMode("full"), r.setApplyResponse(s.applicationResponse);
        break;
    }
    return s;
  };
}, Wa = [
  { id: "AL", name: "AL" },
  { id: "AK", name: "AK" },
  { id: "AZ", name: "AZ" },
  { id: "AR", name: "AR" },
  { id: "AA", name: "AA" },
  { id: "AE", name: "AE" },
  { id: "AP", name: "AP" },
  { id: "AS", name: "AS" },
  { id: "CA", name: "CA" },
  { id: "CO", name: "CO" },
  { id: "CT", name: "CT" },
  { id: "DC", name: "DC" },
  { id: "DE", name: "DE" },
  { id: "FL", name: "FL" },
  { id: "FM", name: "FM" },
  { id: "GA", name: "GA" },
  { id: "GU", name: "GU" },
  { id: "HI", name: "HI" },
  { id: "ID", name: "ID" },
  { id: "IL", name: "IL" },
  { id: "IN", name: "IN" },
  { id: "IA", name: "IA" },
  { id: "KS", name: "KS" },
  { id: "KY", name: "KY" },
  { id: "LA", name: "LA" },
  { id: "ME", name: "ME" },
  { id: "MD", name: "MD" },
  { id: "MA", name: "MA" },
  { id: "MI", name: "MI" },
  { id: "MN", name: "MN" },
  { id: "MS", name: "MS" },
  { id: "MO", name: "MO" },
  { id: "MT", name: "MT" },
  { id: "MH", name: "MH" },
  { id: "MP", name: "MP" },
  { id: "NE", name: "NE" },
  { id: "NV", name: "NV" },
  { id: "NH", name: "NH" },
  { id: "NJ", name: "NJ" },
  { id: "NM", name: "NM" },
  { id: "NY", name: "NY" },
  { id: "NC", name: "NC" },
  { id: "ND", name: "ND" },
  { id: "OH", name: "OH" },
  { id: "OK", name: "OK" },
  { id: "OR", name: "OR" },
  { id: "PA", name: "PA" },
  { id: "PR", name: "PR" },
  { id: "PW", name: "PW" },
  { id: "RI", name: "RI" },
  { id: "SC", name: "SC" },
  { id: "SD", name: "SD" },
  { id: "TN", name: "TN" },
  { id: "TX", name: "TX" },
  { id: "UT", name: "UT" },
  { id: "VT", name: "VT" },
  { id: "VA", name: "VA" },
  { id: "VI", name: "VI" },
  { id: "WA", name: "WA" },
  { id: "WV", name: "WV" },
  { id: "WI", name: "WI" },
  { id: "WY", name: "WY" }
], ja = [
  { id: "USA", name: "United States of America" },
  { id: "AFG", name: "Afghanistan" },
  { id: "ALB", name: "Albania" },
  { id: "DZA", name: "Algeria" },
  { id: "ASM", name: "American Samoa" },
  { id: "AND", name: "Andorra" },
  { id: "AGO", name: "Angola" },
  { id: "AIA", name: "Anguilla" },
  { id: "ATA", name: "Antarctica" },
  { id: "ATG", name: "Antigua and Barbuda" },
  { id: "ARG", name: "Argentina" },
  { id: "ARM", name: "Armenia" },
  { id: "ABW", name: "Aruba " },
  { id: "AUS", name: "Australia" },
  { id: "AUT", name: "Austria" },
  { id: "AZE", name: "Azerbaijan" },
  { id: "BHS", name: "Bahamas" },
  { id: "BHR", name: "Bahrain" },
  { id: "BGD", name: "Bangladesh" },
  { id: "BRB", name: "Barbados" },
  { id: "BLR", name: "Belarus" },
  { id: "BEL", name: "Belgium" },
  { id: "BLZ", name: "Belize" },
  { id: "BEN", name: "Benin" },
  { id: "BMU", name: "Bermuda" },
  { id: "BTN", name: "Bhutan" },
  { id: "BOL", name: "Bolivia (Plurinational State of)" },
  { id: "BES", name: "Bonaire, Sint Eustatius and Saba" },
  { id: "BIH", name: "Bosnia and Herzegovina" },
  { id: "BWA", name: "Botswana" },
  { id: "BVT", name: "Bouvet Island" },
  { id: "BRA", name: "Brazil" },
  { id: "IOT", name: "British Indian Ocean Territory" },
  { id: "BRN", name: "Brunei Darussalam" },
  { id: "BGR", name: "Bulgaria" },
  { id: "BFA", name: "Burkina Faso" },
  { id: "BDI", name: "Burundi" },
  { id: "CPV", name: "Cabo Verde" },
  { id: "KHM", name: "Cambodia" },
  { id: "CMR", name: "Cameroon" },
  { id: "CAN", name: "Canada" },
  { id: "CYM", name: "Cayman Islands" },
  { id: "CAF", name: "Central African Republic" },
  { id: "TCD", name: "Chad" },
  { id: "CHL", name: "Chile" },
  { id: "CHN", name: "China" },
  { id: "CXR", name: "Christmas Island" },
  { id: "CCK", name: "Cocos (Keeling) Islands" },
  { id: "COL", name: "Colombia" },
  { id: "COM", name: "Comoros" },
  { id: "COD", name: "Congo (the Democratic Republic of the)" },
  { id: "COG", name: "Congo" },
  { id: "COK", name: "Cook Islands" },
  { id: "CRI", name: "Costa Rica" },
  { id: "HRV", name: "Croatia" },
  { id: "CUB", name: "Cuba" },
  { id: "CUW", name: "Curaçao" },
  { id: "CYP", name: "Cyprus" },
  { id: "CZE", name: "Czechia" },
  { id: "CIV", name: "Côte d'Ivoire" },
  { id: "DNK", name: "Denmark" },
  { id: "DJI", name: "Djibouti" },
  { id: "DMA", name: "Dominica" },
  { id: "DOM", name: "Dominican Republic" },
  { id: "ECU", name: "Ecuador" },
  { id: "EGY", name: "Egypt" },
  { id: "SLV", name: "El Salvador" },
  { id: "GNQ", name: "Equatorial Guinea" },
  { id: "ERI", name: "Eritrea" },
  { id: "EST", name: "Estonia" },
  { id: "SWZ", name: "Eswatini" },
  { id: "ETH", name: "Ethiopia" },
  { id: "FLK", name: "Falkland Islands" },
  { id: "FRO", name: "Faroe Islands" },
  { id: "FJI", name: "Fiji" },
  { id: "FIN", name: "Finland" },
  { id: "FRA", name: "France" },
  { id: "GUF", name: "French Guiana" },
  { id: "PYF", name: "French Polynesia" },
  { id: "ATF", name: "French Southern Territories" },
  { id: "GAB", name: "Gabon" },
  { id: "GMB", name: "Gambia" },
  { id: "GEO", name: "Georgia" },
  { id: "DEU", name: "Germany" },
  { id: "GHA", name: "Ghana" },
  { id: "GIB", name: "Gibraltar" },
  { id: "GRC", name: "Greece" },
  { id: "GRL", name: "Greenland" },
  { id: "GRD", name: "Grenada" },
  { id: "GLP", name: "Guadeloupe" },
  { id: "GUM", name: "Guam" },
  { id: "GTM", name: "Guatemala" },
  { id: "GGY", name: "Guernsey" },
  { id: "GIN", name: "Guinea" },
  { id: "GNB", name: "Guinea-Bissau" },
  { id: "GUY", name: "Guyana" },
  { id: "HTI", name: "Haiti" },
  { id: "HMD", name: "Heard Island and McDonald Islands" },
  { id: "VAT", name: "Holy See" },
  { id: "HND", name: "Honduras" },
  { id: "HKG", name: "Hong Kong" },
  { id: "HUN", name: "Hungary" },
  { id: "ISL", name: "Iceland" },
  { id: "IND", name: "India" },
  { id: "IDN", name: "Indonesia" },
  { id: "IRN", name: "Iran" },
  { id: "IRQ", name: "Iraq" },
  { id: "IRL", name: "Ireland" },
  { id: "IMN", name: "Isle of Man" },
  { id: "ISR", name: "Israel" },
  { id: "ITA", name: "Italy" },
  { id: "JAM", name: "Jamaica" },
  { id: "JPN", name: "Japan" },
  { id: "JEY", name: "Jersey" },
  { id: "JOR", name: "Jordan" },
  { id: "KAZ", name: "Kazakhstan" },
  { id: "KEN", name: "Kenya" },
  { id: "KIR", name: "Kiribati" },
  { id: "PRK", name: "Korea (the Democratic People's Republic of)" },
  { id: "KOR", name: "Korea (the Republic of)" },
  { id: "KWT", name: "Kuwait" },
  { id: "KGZ", name: "Kyrgyzstan" },
  { id: "LAO", name: "Lao People's Democratic Republic" },
  { id: "LVA", name: "Latvia" },
  { id: "LBN", name: "Lebanon" },
  { id: "LSO", name: "Lesotho" },
  { id: "LBR", name: "Liberia" },
  { id: "LBY", name: "Libya" },
  { id: "LIE", name: "Liechtenstein" },
  { id: "LTU", name: "Lithuania" },
  { id: "LUX", name: "Luxembourg" },
  { id: "MAC", name: "Macao" },
  { id: "MDG", name: "Madagascar" },
  { id: "MWI", name: "Malawi" },
  { id: "MYS", name: "Malaysia" },
  { id: "MDV", name: "Maldives" },
  { id: "MLI", name: "Mali" },
  { id: "MLT", name: "Malta" },
  { id: "MHL", name: "Marshall Islands" },
  { id: "MTQ", name: "Martinique" },
  { id: "MRT", name: "Mauritania" },
  { id: "MUS", name: "Mauritius" },
  { id: "MYT", name: "Mayotte" },
  { id: "MEX", name: "Mexico" },
  { id: "FSM", name: "Micronesia" },
  { id: "MDA", name: "Moldova" },
  { id: "MCO", name: "Monaco" },
  { id: "MNG", name: "Mongolia" },
  { id: "MNE", name: "Montenegro" },
  { id: "MSR", name: "Montserrat" },
  { id: "MAR", name: "Morocco" },
  { id: "MOZ", name: "Mozambique" },
  { id: "MMR", name: "Myanmar" },
  { id: "NAM", name: "Namibia" },
  { id: "NRU", name: "Nauru" },
  { id: "NPL", name: "Nepal" },
  { id: "NLD", name: "Netherlands" },
  { id: "NCL", name: "New Caledonia" },
  { id: "NZL", name: "New Zealand" },
  { id: "NIC", name: "Nicaragua" },
  { id: "NER", name: "Niger" },
  { id: "NGA", name: "Nigeria" },
  { id: "NIU", name: "Niue" },
  { id: "NFK", name: "Norfolk Island" },
  { id: "MNP", name: "Northern Mariana Islands" },
  { id: "NOR", name: "Norway" },
  { id: "OMN", name: "Oman" },
  { id: "PAK", name: "Pakistan" },
  { id: "PLW", name: "Palau" },
  { id: "PSE", name: "Palestine, State of" },
  { id: "PAN", name: "Panama" },
  { id: "PNG", name: "Papua New Guinea" },
  { id: "PRY", name: "Paraguay" },
  { id: "PER", name: "Peru" },
  { id: "PHL", name: "Philippines" },
  { id: "PCN", name: "Pitcairn" },
  { id: "POL", name: "Poland" },
  { id: "PRT", name: "Portugal" },
  { id: "PRI", name: "Puerto Rico" },
  { id: "QAT", name: "Qatar" },
  { id: "MKD", name: "Republic of North Macedonia" },
  { id: "ROU", name: "Romania" },
  { id: "RUS", name: "Russian Federation" },
  { id: "RWA", name: "Rwanda" },
  { id: "REU", name: "Réunion" },
  { id: "BLM", name: "Saint Barthélemy" },
  { id: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "KNA", name: "Saint Kitts and Nevis" },
  { id: "LCA", name: "Saint Lucia" },
  { id: "MAF", name: "Saint Martin (French part)" },
  { id: "SPM", name: "Saint Pierre and Miquelon" },
  { id: "VCT", name: "Saint Vincent and the Grenadines" },
  { id: "WSM", name: "Samoa" },
  { id: "SMR", name: "San Marino" },
  { id: "STP", name: "Sao Tome and Principe" },
  { id: "SAU", name: "Saudi Arabia" },
  { id: "SEN", name: "Senegal" },
  { id: "SRB", name: "Serbia" },
  { id: "SYC", name: "Seychelles" },
  { id: "SLE", name: "Sierra Leone" },
  { id: "SGP", name: "Singapore" },
  { id: "SXM", name: "Sint Maarten (Dutch part)" },
  { id: "SVK", name: "Slovakia" },
  { id: "SVN", name: "Slovenia" },
  { id: "SLB", name: "Solomon Islands" },
  { id: "SOM", name: "Somalia" },
  { id: "ZAF", name: "South Africa" },
  { id: "SGS", name: "South Georgia and the South Sandwich Islands" },
  { id: "SSD", name: "South Sudan" },
  { id: "ESP", name: "Spain" },
  { id: "LKA", name: "Sri Lanka" },
  { id: "SDN", name: "Sudan" },
  { id: "SUR", name: "Suriname" },
  { id: "SJM", name: "Svalbard and Jan Mayen" },
  { id: "SWE", name: "Sweden" },
  { id: "CHE", name: "Switzerland" },
  { id: "SYR", name: "Syrian Arab Republic" },
  { id: "TWN", name: "Taiwan (Province of China)" },
  { id: "TJK", name: "Tajikistan" },
  { id: "TZA", name: "Tanzania, United Republic of" },
  { id: "THA", name: "Thailand" },
  { id: "TLS", name: "Timor-Leste" },
  { id: "TGO", name: "Togo" },
  { id: "TKL", name: "Tokelau" },
  { id: "TON", name: "Tonga" },
  { id: "TTO", name: "Trinidad and Tobago" },
  { id: "TUN", name: "Tunisia" },
  { id: "TUR", name: "Turkey" },
  { id: "TKM", name: "Turkmenistan" },
  { id: "TCA", name: "Turks and Caicos Islands" },
  { id: "TUV", name: "Tuvalu" },
  { id: "UGA", name: "Uganda" },
  { id: "UKR", name: "Ukraine" },
  { id: "ARE", name: "United Arab Emirates" },
  { id: "GBR", name: "United Kingdom of Great Britain and Northern Ireland" },
  { id: "UMI", name: "United States Minor Outlying Islands" },
  { id: "URY", name: "Uruguay" },
  { id: "UZB", name: "Uzbekistan" },
  { id: "VUT", name: "Vanuatu" },
  { id: "VEN", name: "Venezuela" },
  { id: "VNM", name: "Viet Nam" },
  { id: "VGB", name: "Virgin Islands (British)" },
  { id: "VIR", name: "Virgin Islands (U.S.)" },
  { id: "WLF", name: "Wallis and Futuna" },
  { id: "ESH", name: "Western Sahara" },
  { id: "YEM", name: "Yemen" },
  { id: "ZMB", name: "Zambia" },
  { id: "ZWE", name: "Zimbabwe" },
  { id: "ALA", name: "Åland Islands" }
], Ha = (e, t) => {
  const r = g();
  return de(
    (n) => r.deliverApplicationDocuments(f(e), n),
    t
  );
}, za = (e, t, r) => {
  const n = g();
  return Me(async () => {
    const s = await n.verifyApplicationDocumentsDelivery(
      f(e),
      f(t)
    );
    return await r(s.verified), s.verified;
  }, 1e4, {
    immediate: !1,
    manual: !0
  });
}, Ya = (e, t) => {
  const n = ("" + e).replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/);
  return n ? t == null || t == "parenthetical" ? `(${n[1]}) ${n[2]}-${n[3]}` : `${n[1]}-${n[2]}-${n[3]}` : null;
};
function Qa(e) {
  if (isNaN(e) || !Number.isInteger(e))
    return "Invalid input: Not an integer";
  const t = e % 10, r = e % 100;
  if (r >= 11 && r <= 13)
    return e + "th";
  switch (t) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
    default:
      return e + "th";
  }
}
const Ja = (e, t = 4, r = "-") => {
  if (!e)
    return e;
  const n = new RegExp(`.{1,${t}}`, "g");
  return e.match(n)?.join(r);
}, Za = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[1]}-${n[2]}-${n[3]}` : null;
}, Xa = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[3]}` : null;
}, ec = (e) => {
  const t = g(), r = v();
  return async (n) => {
    const i = f(e), s = await t.answerQuiz(i, n);
    if (s.status === "pending" && s.providerId === "acima") {
      const o = (await t.checkApplication(i)).provider;
      if (o) {
        r.setApplyResponse(o);
        const c = o.quizResponse?.quizId ? o.quizResponse : void 0;
        return {
          ...s,
          // If the quiz id is the same as the current quiz then it has failed
          // If the quiz id is different then another quiz needs to be completed
          status: c?.quizId === n.quizId ? "fail" : "pass",
          next: c
        };
      }
    }
    return s;
  };
}, tc = (e, t) => {
  const r = v();
  return m(() => {
    const i = r.findApplyResponse(f(e))?.quizResponse;
    return i?.quizId === f(t) ? i : void 0;
  });
}, rc = () => sn(Q()), nc = (e) => {
  const t = Q(), r = on({
    inheritLocale: !1
  }), n = $e({
    useScope: "global"
  }), i = () => {
    const s = f(e), a = `${s ? N(s) : "all"}_${t.language}`, o = `${s ? N(s) : "all"}_${t.locale}`;
    r.locale.value = o, r.fallbackLocale.value = [
      a,
      ...n.fallbackLocale.value
    ];
    const c = n.messages.value;
    o in c && r.mergeLocaleMessage(o, c[o]), a in c && r.mergeLocaleMessage(a, c[a]);
  };
  return Qr(() => i()), q(
    () => t.locale,
    () => i()
  ), r;
}, ic = {
  legacy: !1,
  /**
   * The locale of localization.
   *
   * If the locale contains a territory and a dialect,
   * this locale contains an implicit fallback.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#locale-1
   */
  locale: "en",
  /**
   * The locale of fallback localization.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbacklocale-1
   */
  fallbackLocale: ["en"],
  /**
   * In the component localization, whether to fall back to root level (global scope)
   * localization when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackroot-1
   */
  fallbackRoot: !0,
  /**
   * Whether suppress warnings outputted when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#missingwarn-1
   */
  missingWarn: !1,
  /**
   * Whether suppress warnings when falling back to either fallbackLocale or root.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackwarn-1
   */
  fallbackWarn: !1
}, sc = (e) => {
  const t = g(), r = b("useLaunchMobileApply"), n = async () => await t.launchFromMobileDevice(
    zs(e)
  ), { error: i, isLoading: s, isReady: a, state: o, execute: c, executeImmediate: l } = be(
    n,
    {
      success: !1
    },
    {
      immediate: !1,
      onError: (d) => r.error("Failed to launch on mobile device ", d)
    }
  );
  return {
    error: i,
    isLoading: s,
    isReady: a,
    state: o,
    refresh: c,
    submit: l
  };
}, zs = (e) => {
  const t = w(), r = f(e);
  switch (r) {
    case "sms":
      return {
        mobilePhone: t.getApplicationValue(
          "primary.mobilePhone"
        )
      };
    case "email":
      return {
        email: t.getApplicationValue("primary.email")
      };
    default:
      throw new Error(
        `${r} is not supported. Try something else!`
      );
  }
}, oc = (e) => {
  const t = g(), r = b("useQrCodeLaunch"), n = async () => {
    const l = f(e);
    return await t.launchApplicationFromQrCode({
      config: {
        startAt: l.startAt,
        prefill: {
          primaryApplicant: Ys()
        }
      }
    });
  }, { error: i, isLoading: s, isReady: a, state: o, execute: c } = be(
    n,
    {
      url: void 0,
      expires: void 0
    },
    {
      onError: (l) => r.error("Failed to fetch QR code ", l)
    }
  );
  return {
    error: i,
    isLoading: s,
    isReady: a,
    state: o,
    refresh: c
  };
}, Ys = () => {
  const e = w();
  return {
    firstName: e.getApplicationValue("primary.firstName"),
    lastName: e.getApplicationValue("primary.lastName"),
    dateOfBirth: e.getApplicationValue("primary.dateOfBirth"),
    email: e.getApplicationValue("primary.email"),
    homePhone: e.getApplicationValue("primary.homePhone"),
    mobilePhone: e.getApplicationValue("primary.mobilePhone"),
    address: {
      line1: e.getApplicationValue("primary.homeAddress.line1"),
      line2: e.getApplicationValue("primary.homeAddress.line2"),
      city: e.getApplicationValue("primary.homeAddress.city"),
      state: e.getApplicationValue("primary.homeAddress.state"),
      zipCode: e.getApplicationValue(
        "primary.homeAddress.zipCode"
      )
    }
  };
}, ac = () => {
  const e = He(), { t, te: r } = $e({
    useScope: "parent"
  });
  return m(
    () => e.name ?? (r("merchant.name") ? t("merchant.name") : void 0)
  );
}, cc = () => {
  const e = He(), { t } = $e({
    useScope: "parent"
  });
  return m(() => e.legalName ?? t("merchant.legal_name"));
}, lc = (e, t) => {
  const r = b("useFetchZipCodeMetadata()"), n = g(), i = F(!1), s = de(async (o) => {
    try {
      const c = await n.getZipCodeMetadata(o);
      t(c), await x();
    } catch (c) {
      B(c), r.error("Failed to fetch zip code metadata", c);
    }
  }, i), a = cn(
    () => f(e),
    (o) => {
      if (o != null && o.length >= 5)
        return s(o);
    }
  );
  return zt(() => {
    a();
  }), m(() => i.value);
}, xr = () => {
  const e = b("useApplicablePreauthResponses"), t = yr(), r = v();
  return m(() => {
    const n = f(t), i = r.findProviderConfig(n);
    return i == null ? (e.error(
      `Unable to determine offers, config for ${n} is missing`
    ), []) : r.preauthResponses.filter((s) => {
      const { responseCode: a, providerKey: o } = s, c = r.findProviderConfig(o);
      return c == null ? (e.warn(`Skipping response for ${o}, config is missing`), !1) : a !== u.PREQUALIFIED && a !== u.PREAPPROVED ? !1 : o === n ? !0 : r.findApplyResponse(o) ? !1 : i.cascadeGroup === c.cascadeGroup;
    });
  });
}, Fe = (e, t) => [e, t].join(":"), Qs = (e) => e.filter(
  (t) => t.providerProductType == null || t.providerProductType === "credit"
), Js = (e) => e.filter(
  (t) => t.providerProductType === "loan" || t.providerProductType === "bnpl"
), Ct = (e) => {
  const t = e.map((r) => r.approvedAmountCents).filter((r) => r != null);
  return Math.max(...t);
}, dc = (e) => {
  const t = v(), r = xr(), n = (s) => {
    const a = t.findProviderConfig(s.providerKey), o = t.findPaymentPlans(s.providerKey), c = (d) => Pn(
      d,
      o.sort?.byFields ?? [
        "monthlyAmountCents",
        "paymentAmountCents",
        "minAmountCents",
        "providerKey"
      ]
    );
    if (s.providerId === "synchrony" && a?.providerProduct === "synchrony-multi-product") {
      const d = [], p = Qs(o.paymentPlans);
      if (p.length > 0) {
        const P = structuredClone(it(s));
        P.approvedAmountCents = Ct(p), d.push({
          id: Fe(s.providerKey, "credit"),
          providerKey: s.providerKey,
          response: P,
          plans: c(p),
          productType: "credit",
          partialCoverage: !1
        });
      }
      const C = Js(o.paymentPlans);
      if (C.length > 0) {
        const P = structuredClone(it(s));
        P.approvedAmountCents = Ct(C), d.push({
          id: Fe(s.providerKey, "loan"),
          providerKey: s.providerKey,
          response: P,
          plans: c(C),
          productType: "loan",
          partialCoverage: !1
        });
      }
      return d;
    }
    const l = c(o.paymentPlans);
    return [
      {
        id: Fe(s.providerKey, "unknown"),
        providerKey: s.providerKey,
        response: s,
        plans: l,
        productType: a?.providerProductType,
        partialCoverage: !1
      }
    ];
  }, i = (s, a) => {
    const o = t.cascade.findIndex(
      (l) => l.providerKey === s.providerKey
    ) ?? 0, c = t.cascade.findIndex(
      (l) => l.providerKey === a.providerKey
    ) ?? 0;
    return o - c;
  };
  return m(
    () => f(r).flatMap((s) => n(s)).filter(
      (s) => s != null && e.has(s.response.providerId)
    ).sort((s, a) => i(s, a))
  );
}, uc = (e) => {
  const t = xr();
  return m(
    () => t.value.every(({ providerId: r }) => e.has(r))
  );
}, Zs = [
  u.PREQUALIFIED,
  u.PREAPPROVED,
  u.APPROVED
], Xs = (e) => e && Zs.includes(e.responseCode), Mt = () => ({
  paymentPlans: []
}), eo = (e) => {
  const t = U(e.providerKey);
  return Xs(e) || t.fetchPaymentPlansOnError;
}, to = (e = {}) => {
  const t = b("useFetchPaymentPlans"), r = g(), n = Ps(e.providerKey), i = v(), s = ce(), a = gs();
  return async (o) => {
    const c = f(n);
    if (c?.providerKey == null)
      return t.error("Unable to fetch payment plans, provider is not known"), Mt();
    const l = c.providerKey;
    if (eo(c)) {
      const d = c.approvedAmountCents ?? 0, p = o?.purchaseAmount ?? s.value ?? d, C = o?.downPaymentAmount ?? Se(
        d,
        p,
        o?.downPaymentAmount ?? a.value
      ), P = await r.getPaymentPlans(
        c.providerKey,
        p,
        C
      );
      return i.setPaymentPlans(c.providerKey, P), P;
    } else
      return t.warn(
        `Refusing to fetch payment plans for: ${l} with response code: ${c.responseCode}`
      ), Mt();
  };
}, ro = (e, t) => m(() => {
  const r = f(e);
  return f(t).find((n) => n.id === r);
}), no = (e) => m(() => {
  const t = f(e);
  if (t?.productType === "loan" || t?.productType === "bnpl") {
    const r = t.plans.map((n) => n.minAmountCents).filter((n) => n !== void 0);
    if (r.length)
      return Math.max(Math.min(...r), 1);
  }
  return 1;
}), io = (e, t) => m(() => {
  const r = e.value?.response;
  if (!r)
    return 0;
  const n = U(r.providerId), i = r.approvedAmountCents ?? 0, s = n.excludePurchaseAmountFromMaxFinancing ? Number.MAX_SAFE_INTEGER : t.value;
  return Math.min(i, s);
}), pc = (e, t) => {
  const r = f(t), n = w(), i = ro(e, r), s = m(() => i.value?.providerKey), a = m(
    () => n.getApplicationValue("purchaseAmountCents") ?? 0
  ), o = F(a.value), c = F(!1), l = to({
    providerKey: s
  }), d = no(i), p = io(
    i,
    o
  ), C = Xt(
    (E, I) => {
      if (I != null)
        return l({
          purchaseAmount: E
        });
    }
  ), P = ln(async (E) => {
    if (!(E > p.value) && !(E < d.value)) {
      c.value = !0;
      try {
        return await C(E, f(s));
      } finally {
        c.value = !1;
      }
    }
  }, 500);
  return q(o, P), q(i, (E, I) => {
    if (I?.id !== E?.id) {
      const j = E?.response?.approvedAmountCents, h = a.value;
      o.value = j == null ? h : Math.min(j, h);
    }
  }), {
    fetchingPlans: c,
    financedAmountCents: o,
    minFinanceAmountCents: d,
    maxFinanceAmountCents: p
  };
}, so = () => {
  const e = w();
  return m({
    get: () => e.selectedPlan,
    set: (t) => e.selectedPlan = t
  });
}, fc = (e, t) => {
  const r = v();
  return m(() => {
    const n = f(e), i = f(t), s = r.findPaymentPlan(n, i);
    if (!s)
      throw new Error(`${i} was not found for ${n}`);
    return s;
  });
}, hc = (e) => {
  const t = b("useReviewOffer"), r = v(), n = so(), i = F(), s = ce(i), a = Ye();
  return de(async (o, c, l, d) => {
    if (o == null) {
      t.warn("Refusing to review offer, provider key is undefined");
      return;
    }
    const p = Wi(() => o);
    i.value = o;
    const C = m(
      () => !!p.value?.requiresSelectPlan
    );
    if (c == null && C.value) {
      t.warn("Refusing to review offer, plan is undefined");
      return;
    }
    c != null && (n.value = c), l != null && (s.value = l);
    const E = r.findProviderConfig(o)?.applyModes?.find((I) => I !== "full");
    o !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      o,
      "and apply mode:",
      E
    ), await a({
      providerKey: o,
      applyMode: E
    })), await d();
  }, e);
}, mc = (e) => {
  const t = b("useSelectOffer"), r = v(), n = Hi(), i = Ye();
  return de(async (s, a, o) => {
    const l = vr(() => s).value?.applyModes?.find((d) => d !== "full");
    s !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      s,
      "and apply mode:",
      l
    ), await i({
      providerKey: s,
      applyMode: l
    })), t.info(
      "Selecting payment plan:",
      a.providerKey,
      " -> ",
      a.providerPlanCode
    ), await n.selectPaymentPlan(a), await o();
  }, e);
};
var Ne, It;
function oo() {
  return It || (It = 1, Ne = {}), Ne;
}
var yc = oo();
const ao = () => window.webKiosk;
class co {
}
class lo extends co {
  constructor(t, r) {
    super(), this._settings = t, this._printer = r;
  }
  get printerName() {
    return this._settings.printerName;
  }
  get pageWidth() {
    return this._settings.pageWidth;
  }
  get pageHeight() {
    return this._settings.pageHeight ?? 11;
  }
  print(t) {
    return this._printer.print(this.printerName, t);
  }
}
const Lr = () => {
  const e = b("useReceiptPrinter"), t = ao();
  return async () => {
    if (t) {
      const r = await t.printer.getSettings();
      if (r)
        return e.info(`Using Ticket Printer: ${r.printerName}`), new lo(r, t.printer);
    }
  };
}, vc = () => {
  const e = Lr();
  return dn(async () => await e() != null, !1);
}, gc = (e) => {
  const t = g(), r = Lr();
  return async (n) => {
    e.value = !0;
    try {
      const i = await r();
      if (i == null)
        throw new Error("No Receipt Printer found!");
      const s = {
        printerName: i.printerName,
        pageWidth: i.pageWidth,
        pageHeight: i.pageHeight
      }, a = await t.generateReceipt(n.providerKey, s), o = new Blob([a], {
        type: "application/pdf"
      });
      return i.print(o);
    } finally {
      e.value = !1;
    }
  };
}, Pc = () => {
  const e = O();
  return m(() => e.extensions.find((r) => r.featureId === "prove")?.properties);
}, wc = () => {
  const e = g();
  return () => e.proveResendSms();
}, Ie = k("prove", {
  state: () => ({
    invalidFields: void 0,
    mobilePhone: void 0,
    prefillFields: void 0,
    ssnLast4: void 0,
    linkClicked: !1,
    completed: !1
  }),
  getters: {
    application: () => w().application,
    phoneLast4: (e) => {
      const t = e.mobilePhone;
      if (t != null)
        return t.length > 4 ? t.substring(t.length - 4) : t;
    }
  }
}), Ac = () => {
  const e = g(), t = Ie();
  return async (r) => {
    const n = await e.proveSendSms(r);
    return n.status === "success" && t.$patch({
      ...r
    }), n;
  };
}, Sc = () => {
  const e = $(), t = Ie(), r = w();
  return async () => {
    r.$patch({
      application: {
        primary: {
          mobilePhone: t.mobilePhone
        }
      }
    });
    const n = t.invalidFields?.map(
      (o) => o.fieldPath
    ) ?? [], i = [
      [
        "primary.firstName",
        "primary.middleInitial",
        "primary.lastName",
        "primary.nameSuffix"
      ],
      ["primary.dateOfBirth"],
      ["primary.ssn"],
      ["primary.mobilePhone"],
      [
        "primary.homeAddress.line1",
        "primary.homeAddress.line2",
        "primary.homeAddress.city",
        "primary.homeAddress.state",
        "primary.homeAddress.zipCode"
      ]
    ], s = i.flatMap((o) => o);
    t.prefillFields?.length || (t.prefillFields = e.getFieldsByPath(...s));
    const a = n.map(
      (o) => i.find((c) => c.includes(o)) ?? [o]
    ).flatMap((o) => o);
    e.removeFieldsByPath(
      ...s.filter(
        (o) => !a.includes(o)
      )
    ), await x();
  };
}, Rc = (e) => {
  const t = g(), r = Ie(), n = F();
  Me(async () => {
    const s = await t.getProveSmsStatus();
    return s.status === "clicked" && (r.$patch({
      linkClicked: !0
    }), await x()), s.status !== n.value?.status && (n.value = s, await e(s)), s.status !== "sent";
  }, 5e3);
}, bc = (e) => {
  const t = g(), r = w(), n = Ie(), i = X(), s = F();
  Me(async () => {
    const o = f(i), c = await t.getProveVerificationResult(o);
    if (c.status === "verified") {
      const l = c.applicationData;
      n.completed = !0, n.invalidFields = c.validationResult?.failures, l?.primary?.ssn && delete l.primary.ssn, r.$patch({
        application: {
          ...structuredClone(l)
        },
        originalApplication: {
          hasAgreedToCascade: r.application?.hasAgreedToCascade,
          ...structuredClone(l)
        }
      }), await x();
    }
    return c.status !== s.value?.status && (s.value = c, await e(c)), c.status !== "pending";
  }, 5e3);
}, Ec = (e) => {
  const t = g(), r = b("useMpqDeliveryDetails"), { error: n, state: i, isLoading: s, isReady: a } = be(
    () => t.getSynchronyMpqDeliveryDetails(f(e)),
    void 0,
    {
      onError(o) {
        r.error("Failed getting mpq delivery details", o), B(o);
      }
    }
  );
  return {
    error: n,
    state: i,
    isLoading: s,
    isReady: a
  };
}, Cc = (e) => {
  const t = g(), r = b("useSendMpqDeliveryDetails"), n = F(!1), i = F(!1), s = F();
  return {
    error: s,
    state: n,
    isLoading: i,
    execute: de(async (o) => {
      n.value = !1, s.value = void 0;
      try {
        await t.deliverSynchronyMpqApplicationUrl(f(e), o), n.value = !0;
      } catch (c) {
        r.error(`Failed sending mpq link to ${o}`, c), B(c), s.value = c;
      }
    }, i)
  };
}, Mc = () => {
  const e = g();
  return {
    verify: async (n) => await e.getRecaptchaVerificationResult(n),
    start: async () => e.startRecaptchaVerification()
  };
}, uo = () => {
  const e = O();
  return m(() => e.extensions.find((r) => r.featureId === "recaptcha")?.properties);
}, Ic = () => {
  const e = uo(), t = () => !!window.grecaptcha && !!window.grecaptcha.enterprise && !!window.grecaptcha.enterprise.ready;
  return {
    initializeRecaptcha: (c) => {
      const l = document.createElement("script");
      l.setAttribute(
        "src",
        c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
      ), document.head.appendChild(l);
    },
    executeRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        await window.grecaptcha.enterprise.execute();
      });
    },
    renderRecaptcha: (c, l) => {
      e.value && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.render(c, {
          sitekey: e.value?.siteKey,
          callback: l
        });
      });
    },
    isRecaptchaInitialized: t,
    waitForRecaptchaInitialization: () => new Promise((c) => {
      const l = () => {
        t() ? c() : setTimeout(l, 250);
      };
      l();
    }),
    unloadRecaptcha: (c) => {
      const l = document.head.getElementsByTagName("script");
      for (const d of l)
        d.src.startsWith(
          c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
        ) && document.head.removeChild(d);
    },
    resetRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.reset();
      });
    }
  };
}, Ot = (e) => e.waterfallStatus === "completed" || e.waterfallStatus === "expired", Oc = (e) => {
  const t = g(), r = O();
  Me(async () => {
    const i = r.waterfallResume;
    if (i == null)
      return !0;
    if (Ot(i))
      return await e(i), !0;
    const s = await t.getWaterfallResumeStatus(i.waterfallSessionId);
    return r.updateResume(s), await x(), i.waterfallStatus !== s.waterfallStatus && await e(s), Ot(s);
  }, 5e3);
}, Tc = () => {
  const e = _(), t = O(), r = g(), n = Ve(), i = Z();
  return async (s, a) => {
    const c = await J().instrument("end flow", async () => {
      let d;
      try {
        d = await r.finishFlow(s, a);
      } catch (p) {
        B(p), d = {};
      }
      return t.flowType === "apply" && i({
        type: "end",
        flow: "application",
        outcome: s
      }), d;
    })(), l = c?.transition;
    if (s === "timeout") {
      const d = n.afterEach(() => {
        e.resetAll(), d();
      });
      return c;
    } else
      e.resetAll();
    if (l?.type === "redirect") {
      const d = po(l.destination, r.baseUrl);
      document.body.appendChild(d), d.submit();
    }
    return c;
  };
};
function po(e, t) {
  const r = document.createElement("form"), n = document.createElement("input");
  return r.action = `${t}/api/v1/flow/finish/redirect`, r.method = "POST", r.style.display = "none", n.type = "text", n.name = "destination", n.value = e, r.appendChild(n), r;
}
const _c = () => {
  const e = O(), t = g(), r = Z();
  return async (n) => {
    await t.finishFlow("completed", {
      providerKey: n.providerKey
    }), r({
      type: "checkout",
      applicationId: n.versatileApplicationId,
      applicationWasResumed: e.providerResume?.requestedProviderKey === n.providerKey,
      token: n.checkoutToken
    });
  };
}, Dc = () => {
  const e = O();
  return m(() => (e.storefrontSdk?.enabled ?? !1) && je());
}, Fc = (e = {}) => {
  const t = b("useGenerateTrustEvSessionId"), r = un(
    e.url ?? "https://cdn-us.trustev.com/trustev.min.js",
    () => {
      t.debug("trustev library loaded");
    },
    {
      manual: !0
    }
  );
  return async (n) => {
    await r.load(!0);
    const i = window.TrustevV2;
    if (!i)
      throw new Error("trustev library not found");
    return t.info(`generating a trustev session for ${n}`), new Promise((s, a) => {
      const o = window.setTimeout(
        () => a(
          new Error(
            `timed out waiting for trustev session generation for ${n}`
          )
        ),
        e.timeout ?? 5e3
      );
      i.Init(n, (c) => {
        window.clearTimeout(o), t.info(`successfully generated a trustev session for ${n}`), s(c);
      });
    });
  };
}, Nc = (e) => {
  const t = Pr(), r = f(e), n = Yi(r), i = O(), s = b("useSendCode");
  return async (a, o) => {
    try {
      const c = await t.sendVerificationCode(
        a,
        o
      );
      return n.value && i.flowType === "apply" && (a.email && (n.value.email = a.email), a.mobilePhone && (n.value.mobilePhone = a.mobilePhone)), c;
    } catch (c) {
      return s.error(
        `Failed to send verification code for provider ${o}: `,
        c
      ), {
        status: Wt.ERROR
      };
    }
  };
}, xc = () => {
  const e = Pr(), t = b("useVerifyCode");
  return async (r, n) => {
    try {
      return await e.verifyVerificationCode(
        r,
        n
      );
    } catch (i) {
      return t.error(`Error verifying code for provider ${n}: `, i), {
        status: jt.ERROR
      };
    }
  };
};
function Lc(e, t) {
  const r = F(!1), n = F(!1), i = F(!1);
  return {
    attempted: r,
    unauthorized: n,
    sendSuccess: i,
    verify: async () => {
      i.value = !1, r.value = !0;
      const o = await t();
      return n.value = o.status != jt.SUCCESS, o;
    },
    send: async () => {
      r.value = !1, n.value = !1, i.value = !1;
      const o = await e();
      return i.value = o.status === Wt.SUCCESS, o;
    }
  };
}
const Uc = () => {
  const e = O();
  return () => e.extensions.find(
    (r) => r.flowPosition === "pre_application"
  ) != null;
}, Kc = () => {
  const e = w(), t = b("useIovationBlackbox");
  return async () => (t.info("loading iovation blackbox"), new Promise((r) => {
    window.io_global_object_name = "IGLOO", window.IGLOO = window.IGLOO || {
      enable_flash: !1,
      bb_callback: function(n, i) {
        i && (t.debug("updating device fingerprint with iovation blackbox"), e.setApplicationValue("device.fingerprint", n), r(void 0));
      },
      loader: {
        fp_dyn: !1,
        version: "general5"
      }
    }, import("./iovation-loader-OR6Yh91O.js");
  }));
};
export {
  ki as AccountService,
  Cn as AcimaModule,
  Mn as AdsModule,
  In as AffModule,
  Fr as AppOptionsKey,
  ni as ApplicantOfferModel,
  Vo as ApplicationOfferModel,
  ae as ApplicationService,
  On as AquaModule,
  Tn as BreadModule,
  Ce as Buffers,
  Do as CompositePredicate,
  Be as Content,
  ke as ContentFormat,
  Y as ContentType,
  ht as Contents,
  ja as Countries,
  Qe as DEFAULT_GENERAL_ROUTE_MAPPINGS,
  ic as DefaultI18nOptions,
  ft as DefaultModule,
  me as Device,
  ai as DeviceCapability,
  _n as DividendModule,
  Ke as DynamicProviderKey,
  V as FlowService,
  Dn as FortivaModule,
  Fn as FoundationModule,
  Nn as GafModule,
  Ir as GeneralRouteMappingsKey,
  xn as GenesisModule,
  K as GoogleTagManager,
  Ln as GreenskyModule,
  Un as HfdModule,
  ii as IncomeCollectionType,
  _e as InjectionKeys,
  Kn as KafeneModule,
  Bn as KoalafiModule,
  kn as LendingClubModule,
  qn as LendingPointModule,
  _s as LogicalRouter,
  ri as Modules,
  Gn as MomntModule,
  we as PaymentPlanService,
  Vn as PowerPayModule,
  $n as ProceedModule,
  Wn as ProgressiveModule,
  ji as ProviderSwitchResult,
  H as RoundingMode,
  Or as RouteConditionEvaluatorKey,
  Us as RouterPlugin,
  jn as ServiceFinanceModule,
  bs as Services,
  zn as SnapModule,
  Hn as SonravaModule,
  Wa as States,
  As as StipulationService,
  fe as SubmitApplicationContext,
  he as SubmitApplicationResult,
  Yn as SunlightModule,
  Qn as SynchronyModule,
  Jn as TdBankModule,
  Ss as TermsService,
  Rs as TestCaseService,
  Zn as TgucModule,
  mt as URI,
  Xn as UpgradeModule,
  ws as ValidationService,
  di as VerificationDeliveryMethod,
  mr as VerificationService,
  ei as WatercressModule,
  ti as WellsFargoModule,
  Bo as and,
  sr as applicantByType,
  Fo as approvedResponse,
  Io as arrayRemove,
  Xo as atBottomOfDocument,
  ea as atBottomOfElement,
  vi as buildBufferSource,
  cr as buildEncryptionKey,
  Ko as byJointApplicant,
  Uo as byPrimaryApplicant,
  Se as calculateActualDownPaymentAmount,
  Zo as calculateNextPayDate,
  qo as computedFilter,
  ko as computedQuery,
  Ba as createRelativeRedirect,
  qc as daysBetween,
  Oo as debounce,
  To as debounceAsync,
  Pi as decrypt,
  Bs as defineProviderRoutes,
  li as disclosureToContent,
  yt as downloadBlob,
  mi as downloadContent,
  hi as downloadUrl,
  Ii as enableDevTools,
  gi as encrypt,
  ta as enumToPath,
  ie as executeLater,
  Go as extractOptionalProviderKey,
  N as extractProviderKey,
  ca as fillPath,
  Ue as filter,
  gn as first,
  Ja as formatAccountNumber,
  zo as formatCurrency,
  lr as formatDate,
  Qo as formatLocalDate,
  Jo as formatLocaleDate,
  oa as formatPercent,
  Ya as formatPhone,
  Za as formatSsn,
  Xa as formatSsnLast4,
  Yo as fullDaysBetween,
  hr as generateUUID,
  ui as getAppBaseUrl,
  ci as getDevice,
  fi as getFilenameFromUrl,
  ut as getProperty,
  U as getProviderModule,
  Gc as localDate,
  la as maskOptionalValue,
  Oi as maskValue,
  St as not,
  $o as optionalDisclosureToContent,
  Ho as parseCurrency,
  Rn as pendingResponse,
  pt as prequalifiedResponse,
  na as preventBack,
  Le as query,
  aa as rejectWithMessage,
  Mo as replaceApplyStageInUrlPath,
  zi as reportCustomError,
  B as reportSessionError,
  ir as responseByApplicantType,
  No as responseByProvider,
  bn as responseByProviderKey,
  xo as responseForApplicant,
  Lo as responseForJointApplicant,
  ka as runApp,
  ra as scrollToInvalidElement,
  jo as sendUrlThroughProxy,
  ye as setQueryStringParams,
  _o as sleep,
  Pn as sortBy,
  Qa as toNumberOrdinal,
  Es as toRouteLocation,
  Ee as toUri,
  da as todo,
  Wo as tryToUri,
  Oa as uriToEvent,
  Ta as useAcceptOffer,
  $a as useAccountLookup,
  ec as useAnswerQuiz,
  ma as useAppFieldGroupRules,
  ya as useAppFieldResponse,
  Vc as useAppI18n,
  Nr as useAppOptions,
  _ as useAppStore,
  Yi as useApplicant,
  Ea as useApplicationDocuments,
  rc as useApplicationLocales,
  ze as useApplicationService,
  w as useApplicationStore,
  de as useAsync,
  pc as useCalculateProviderOffers,
  qa as useCheckUserExists,
  xa as useConfirmPaymentPlan,
  Ps as useCurrentApplyResponse,
  ha as useCurrentProviderConfig,
  X as useCurrentProviderKey,
  pa as useCurrentStaticProviderKey,
  Ha as useDeliverApplicationDocuments,
  gs as useDownPaymentAmount,
  Ka as useErrorRouter,
  Ge as useErrorStore,
  Ua as useEvaluateRouteCondition,
  to as useFetchPaymentPlans,
  lc as useFetchZipCodeMetadata,
  $ as useFieldStore,
  Tc as useFinishFlow,
  _c as useFinishWithCheckout,
  Pa as useFlowService,
  Dr as useGeneralRouteMappings,
  Fc as useGenerateTrustEvSessionId,
  Ca as useGetApplyTermsUrl,
  qi as useGetInvalidFields,
  fa as useHasProvidersAfterCurrent,
  ms as useHostedFlowConfig,
  ys as useHostedFlowPersistence,
  Ma as useInstallationAddress,
  Kc as useIovationBlackbox,
  va as useIsAppFieldPresent,
  uc as useIsExploreOffersViewAvailable,
  Uc as useIsPreApplicationWorkflowPresent,
  vc as useIsReceiptPrinterAvailable,
  Dc as useIsStorefrontSdkControlled,
  La as useIsTopoff,
  sc as useLaunchMobileApply,
  Q as useLocaleStore,
  b as useLogger,
  Ga as useLoginProviderUser,
  sa as useMemoize,
  cc as useMerchantLegalName,
  ac as useMerchantName,
  He as useMerchantStore,
  Ec as useMpqDeliveryDetails,
  ia as useNavigationStore,
  Ia as useNextLenderInCascade,
  _a as usePatchApplication,
  Hi as usePaymentPlanService,
  Me as usePolling,
  Da as usePreauthResponse,
  gc as usePrintReceipt,
  Pc as useProveConfig,
  wc as useProveResendSms,
  Ac as useProveSendSms,
  Sc as useProveStartApplication,
  Ie as useProveStore,
  Rc as useProveWaitForSms,
  bc as useProveWaitForVerification,
  vr as useProviderConfig,
  nc as useProviderI18n,
  ga as useProviderInvalidFields,
  Wi as useProviderModule,
  dc as useProviderOffers,
  v as useProviderStore,
  Fa as usePublishApplicationBypassEvent,
  Na as usePublishCascadeConsent,
  Z as usePublishEvent,
  ce as usePurchaseAmount,
  oc as useQrCodeLaunch,
  tc as useQuiz,
  Ic as useRecaptchaApi,
  uo as useRecaptchaConfig,
  Mc as useRecaptchaVerification,
  ba as useRefreshProviderStipulationStatus,
  yr as useRequireCurrentProviderKey,
  fc as useRequireSelectedPlan,
  hc as useReviewOffer,
  Ks as useRouteConditionEvaluator,
  mc as useSelectOffer,
  so as useSelectedPlan,
  Nc as useSendCode,
  Va as useSendLoginPasscode,
  Cc as useSendMpqDeliveryDetails,
  O as useSessionStore,
  gr as useStartProvider,
  wa as useStipulationService,
  vs as useSubmitApplication,
  Ye as useSwitchProvider,
  Aa as useTermsService,
  Sa as useTestCaseService,
  Ra as useValidationService,
  Lc as useVerification,
  Pr as useVerificationService,
  xc as useVerifyCode,
  za as useWaitForApplicationDocumentsVerification,
  Oc as useWaitForWaterfallResume,
  _i as validateAmex,
  Fi as validateDiscover,
  Di as validateMastercard,
  ua as validatePAN,
  Ti as validateVisa,
  ur as windowHasOpener,
  pr as windowHasParent,
  je as windowOpenedExternally
};
//# sourceMappingURL=index.es.js.map
